export default {
  glyphs: {
    '0': {
      ha: 869,
      x_min: 0,
      x_max: 0,
      o:
        'm 435 -19 b 763 297 644 -19 763 118 l 763 675 b 435 992 763 854 644 992 b 107 675 225 992 107 854 l 107 297 b 435 -19 107 118 225 -19 z m 696 678 l 696 294 b 435 36 696 147 606 36 b 174 294 264 36 174 147 l 174 678 b 435 936 174 825 264 936 b 696 678 606 936 696 825 z '
    },
    '1': { ha: 456, x_min: 0, x_max: 0, o: 'm 246 0 l 313 0 l 313 972 l 257 972 l 46 861 l 46 799 l 246 900 z ' },
    '2': {
      ha: 826,
      x_min: 0,
      x_max: 0,
      o:
        'm 107 0 l 717 0 l 717 56 l 185 56 l 574 467 b 711 735 654 553 711 622 b 419 992 711 888 585 992 b 125 721 247 992 125 893 l 125 696 l 188 696 l 188 718 b 419 936 188 857 283 936 b 644 735 547 936 644 856 b 528 507 644 649 597 581 l 107 54 z '
    },
    '3': {
      ha: 840,
      x_min: 0,
      x_max: 0,
      o:
        'm 413 -19 b 739 265 592 -19 739 99 b 433 535 739 428 608 535 l 369 535 l 711 917 l 711 972 l 157 972 l 157 918 l 632 918 l 296 538 l 296 482 l 422 482 b 674 261 569 482 674 400 b 414 36 674 131 568 36 b 156 256 275 36 168 118 l 94 256 b 413 -19 107 81 254 -19 z '
    },
    '4': {
      ha: 844,
      x_min: 0,
      x_max: 0,
      o:
        'm 561 0 l 624 0 l 624 244 l 764 244 l 764 297 l 624 297 l 624 536 l 561 536 l 561 297 l 157 297 l 489 972 l 426 972 l 90 297 l 90 244 l 561 244 z '
    },
    '5': {
      ha: 865,
      x_min: 0,
      x_max: 0,
      o:
        'm 431 -19 b 771 303 626 -19 771 122 b 456 622 771 481 636 622 b 207 514 346 622 263 581 l 279 917 l 692 917 l 692 972 l 225 972 l 135 439 l 201 439 b 446 567 244 504 338 567 b 706 303 601 567 706 446 b 432 36 706 154 596 36 b 175 229 296 36 206 119 l 111 229 b 431 -19 146 78 272 -19 z '
    },
    '6': {
      ha: 828,
      x_min: 0,
      x_max: 0,
      o:
        'm 415 -19 b 744 303 610 -19 744 131 b 439 621 744 476 619 621 b 217 518 336 621 265 583 l 217 519 l 508 972 l 438 972 l 171 544 b 90 299 124 469 90 392 b 415 -19 90 118 228 -19 z m 415 35 b 156 297 264 35 156 143 b 422 568 156 453 274 568 b 679 301 581 568 679 447 b 415 35 679 154 575 35 z '
    },
    '7': { ha: 771, x_min: 0, x_max: 0, o: 'm 179 0 l 247 0 l 688 925 l 688 972 l 97 972 l 97 917 l 619 917 z ' },
    '8': {
      ha: 875,
      x_min: 0,
      x_max: 0,
      o:
        'm 438 -19 b 765 251 629 -19 765 92 b 551 506 765 383 682 475 b 725 738 650 539 725 618 b 438 992 725 890 613 992 b 150 738 263 992 150 890 b 324 506 150 618 225 539 b 110 251 193 475 110 383 b 438 -19 110 92 246 -19 z m 438 32 b 174 251 288 32 174 121 b 438 475 174 392 283 475 b 701 251 592 475 701 392 b 438 32 701 121 588 32 z m 213 735 b 438 940 213 861 303 940 b 663 735 572 940 663 861 b 438 531 663 624 569 531 b 213 735 306 531 213 624 z '
    },
    '9': {
      ha: 825,
      x_min: 0,
      x_max: 0,
      o:
        'm 411 992 b 82 669 217 992 82 853 b 388 351 82 496 206 351 b 610 454 483 351 568 394 l 610 453 l 318 0 l 389 0 l 656 428 b 736 675 699 497 736 582 b 411 992 736 856 599 992 z m 411 938 b 671 675 563 938 671 825 b 404 404 671 525 553 404 b 147 671 239 404 147 521 b 411 938 147 818 251 938 z '
    },
    ' ': { ha: 333, x_min: 0, x_max: 0, o: '' },
    '!': {
      ha: 342,
      x_min: 0,
      x_max: 0,
      o:
        'm 156 211 l 189 211 l 206 528 l 206 972 l 136 972 l 136 528 z m 117 46 b 171 -8 117 14 140 -8 b 225 46 201 -8 225 14 b 171 100 225 78 201 100 b 117 46 140 100 117 78 z '
    },
    '"': { ha: 594, x_min: 0, x_max: 0, o: 'm 411 615 l 467 615 l 467 972 l 411 972 z m 128 615 l 183 615 l 183 972 l 128 972 z ' },
    '#': {
      ha: 936,
      x_min: 0,
      x_max: 0,
      o:
        'm 576 0 l 629 0 l 664 310 l 826 310 l 826 357 l 669 357 l 701 631 l 856 631 l 856 678 l 707 678 l 740 972 l 688 972 l 654 678 l 338 678 l 371 972 l 318 972 l 285 678 l 117 678 l 117 631 l 279 631 l 247 357 l 88 357 l 88 310 l 242 310 l 207 0 l 260 0 l 294 310 l 611 310 z m 332 631 l 649 631 l 617 357 l 300 357 z '
    },
    $: {
      ha: 831,
      x_min: 0,
      x_max: 0,
      o:
        'm 390 -153 l 454 -153 l 454 0 b 731 254 610 11 731 107 b 551 479 731 363 671 433 l 319 568 b 182 733 239 599 182 640 b 411 919 182 853 272 919 b 642 722 551 919 642 842 l 642 685 l 704 685 l 704 724 b 447 971 704 865 597 958 l 447 1125 l 383 1125 l 383 971 b 118 733 219 963 118 875 b 300 513 118 619 183 557 l 533 424 b 667 251 625 389 667 332 b 422 54 667 129 565 54 b 171 263 275 54 171 129 l 171 286 l 107 286 l 107 261 b 390 1 107 108 228 13 z '
    },
    '%': {
      ha: 1164,
      x_min: 0,
      x_max: 0,
      o:
        'm 306 0 l 360 0 l 867 972 l 813 972 z m 500 779 b 299 983 500 899 425 983 b 97 779 172 983 97 899 l 97 651 b 299 447 97 532 172 447 b 500 651 425 447 500 532 z m 299 490 b 149 649 204 490 149 554 l 149 782 b 299 940 149 876 204 940 b 449 782 394 940 449 878 l 449 649 b 299 490 449 553 394 490 z m 1074 321 b 872 525 1074 440 999 525 b 671 321 746 525 671 440 l 671 193 b 872 -11 671 74 746 -11 b 1074 193 999 -11 1074 74 z m 872 32 b 722 190 778 32 722 96 l 722 324 b 872 482 722 418 778 482 b 1022 324 968 482 1022 419 l 1022 190 b 872 32 1022 94 968 32 z '
    },
    '&': {
      ha: 972,
      x_min: 0,
      x_max: 0,
      o:
        'm 679 740 l 679 782 b 443 992 679 899 582 992 b 197 783 297 992 197 906 b 294 581 197 696 242 633 l 304 569 b 97 282 193 522 97 433 b 457 -19 97 101 239 -19 b 758 108 599 -19 697 32 l 885 -19 l 924 19 l 789 156 b 838 351 822 214 838 282 l 838 454 l 779 454 l 779 356 b 747 199 779 299 768 244 l 343 611 b 258 785 304 651 258 710 b 444 942 258 888 340 942 b 621 781 549 942 621 872 l 621 740 z m 457 32 b 160 283 286 32 160 126 b 343 531 160 415 243 485 l 719 149 b 457 32 668 78 582 32 z '
    },
    "'": { ha: 311, x_min: 0, x_max: 0, o: 'm 128 615 l 183 615 l 183 972 l 128 972 z ' },
    '(': {
      ha: 410,
      x_min: 0,
      x_max: 0,
      o: 'm 282 1086 b 114 450 168 857 114 675 b 282 -186 114 225 168 43 l 347 -186 b 181 450 231 60 181 238 b 347 1086 181 663 231 840 z '
    },
    ')': {
      ha: 410,
      x_min: 0,
      x_max: 0,
      o: 'm 63 1086 b 229 450 179 840 229 663 b 63 -186 229 238 179 60 l 128 -186 b 296 450 242 43 296 225 b 128 1086 296 675 242 857 z '
    },
    '*': {
      ha: 603,
      x_min: 0,
      x_max: 0,
      o:
        'm 100 847 l 264 750 l 100 654 l 119 622 l 283 718 l 283 528 l 321 528 l 321 718 l 483 622 l 503 654 l 338 750 l 503 847 l 483 879 l 321 782 l 321 972 l 283 972 l 283 782 l 119 879 z '
    },
    '+': {
      ha: 844,
      x_min: 0,
      x_max: 0,
      o: 'm 393 181 l 451 181 l 451 474 l 726 474 l 726 526 l 451 526 l 451 819 l 393 819 l 393 526 l 118 526 l 118 474 l 393 474 z '
    },
    ',': { ha: 308, x_min: 0, x_max: 0, o: 'm 49 -149 l 104 -149 l 193 136 l 119 136 z ' },
    '-': { ha: 576, x_min: 0, x_max: 0, o: 'm 101 403 l 475 403 l 475 457 l 101 457 z ' },
    '.': {
      ha: 308,
      x_min: 0,
      x_max: 0,
      o: 'm 100 46 b 154 -8 100 14 124 -8 b 208 46 185 -8 208 14 b 154 100 208 78 185 100 b 100 46 124 100 100 78 z '
    },
    '/': { ha: 622, x_min: 0, x_max: 0, o: 'm 86 -146 l 150 -146 l 542 1042 l 478 1042 z ' },
    ':': {
      ha: 308,
      x_min: 0,
      x_max: 0,
      o:
        'm 100 46 b 154 -8 100 14 124 -8 b 208 46 185 -8 208 14 b 154 100 208 78 185 100 b 100 46 124 100 100 78 z m 100 526 b 154 472 100 494 124 472 b 208 526 185 472 208 494 b 154 581 208 558 185 581 b 100 526 124 581 100 558 z '
    },
    ';': {
      ha: 308,
      x_min: 0,
      x_max: 0,
      o:
        'm 38 -149 l 93 -149 l 182 136 l 108 136 z m 100 528 b 154 474 100 496 124 474 b 208 528 185 474 208 496 b 154 582 208 560 185 582 b 100 528 124 582 100 560 z '
    },
    '<': { ha: 824, x_min: 0, x_max: 0, o: 'm 90 521 l 90 479 l 699 167 l 699 224 l 158 500 l 699 776 l 699 833 z ' },
    '=': { ha: 851, x_min: 0, x_max: 0, o: 'm 132 310 l 719 310 l 719 361 l 132 361 z m 132 639 l 719 639 l 719 690 l 132 690 z ' },
    '>': { ha: 824, x_min: 0, x_max: 0, o: 'm 125 833 l 125 776 l 665 500 l 125 224 l 125 167 l 733 479 l 733 521 z ' },
    '?': {
      ha: 689,
      x_min: 0,
      x_max: 0,
      o:
        'm 271 221 l 332 221 l 332 304 b 435 507 332 414 357 449 l 501 557 b 613 763 572 610 613 683 b 336 992 613 896 501 992 b 72 746 178 992 72 899 l 72 722 l 133 722 l 133 744 b 336 938 133 868 213 938 b 546 763 464 938 546 865 b 442 586 546 686 508 636 l 382 542 b 271 304 296 478 271 425 z m 251 46 b 306 -8 251 14 275 -8 b 360 46 336 -8 360 14 b 306 100 360 78 336 100 b 251 46 275 100 251 78 z '
    },
    '@': {
      ha: 1313,
      x_min: 0,
      x_max: 0,
      o:
        'm 660 -157 b 917 -118 749 -157 846 -142 l 924 -71 b 665 -110 844 -96 758 -110 b 160 390 326 -110 160 129 b 690 944 160 708 376 944 b 1160 503 976 944 1160 753 b 964 200 1160 351 1092 200 b 833 340 888 200 833 250 b 838 386 833 354 835 369 l 888 667 l 836 667 l 817 549 b 639 679 800 613 736 679 b 422 465 517 679 444 596 l 415 425 b 411 374 413 407 411 390 b 604 174 411 257 486 174 b 794 300 688 174 761 222 b 958 157 799 218 869 157 b 1213 504 1133 157 1213 336 b 692 992 1213 774 1013 992 b 107 392 342 992 107 729 b 660 -157 107 92 304 -157 z m 476 457 b 642 633 496 569 550 633 b 792 465 731 633 792 551 b 789 435 792 456 790 444 l 781 386 b 610 219 764 293 696 219 b 465 371 519 219 465 278 b 469 418 465 386 467 401 z '
    },
    A: {
      ha: 919,
      x_min: 0,
      x_max: 0,
      o: 'm 494 972 l 425 972 l 56 0 l 126 0 l 224 267 l 694 267 l 793 0 l 864 0 z m 460 908 l 674 324 l 244 324 z '
    },
    B: {
      ha: 911,
      x_min: 0,
      x_max: 0,
      o:
        'm 135 0 l 526 0 b 835 261 721 0 835 107 b 625 504 835 396 753 472 b 778 731 722 546 778 628 b 518 972 778 864 681 972 l 135 972 z m 200 54 l 200 471 l 521 471 b 768 264 669 471 768 385 b 519 54 768 135 682 54 z m 200 525 l 200 918 l 503 918 b 711 725 639 918 711 832 b 503 525 711 624 640 525 z '
    },
    C: {
      ha: 971,
      x_min: 0,
      x_max: 0,
      o:
        'm 499 -19 b 874 310 718 -19 857 131 l 808 310 b 497 38 789 163 685 38 b 175 397 283 38 175 190 l 175 575 b 497 935 175 782 283 935 b 808 663 685 935 789 810 l 874 663 b 499 992 857 842 718 992 b 107 574 240 992 107 811 l 107 399 b 499 -19 107 161 240 -19 z '
    },
    D: {
      ha: 968,
      x_min: 0,
      x_max: 0,
      o:
        'm 864 374 l 864 599 b 481 972 864 808 728 972 l 135 972 l 135 0 l 481 0 b 864 374 728 0 864 164 z m 796 597 l 796 375 b 472 57 796 186 681 57 l 203 57 l 203 915 l 472 915 b 796 597 681 915 796 786 z '
    },
    E: {
      ha: 840,
      x_min: 0,
      x_max: 0,
      o: 'm 135 0 l 760 0 l 760 57 l 203 57 l 203 464 l 718 464 l 718 522 l 203 522 l 203 915 l 758 915 l 758 972 l 135 972 z '
    },
    F: {
      ha: 804,
      x_min: 0,
      x_max: 0,
      o: 'm 135 0 l 203 0 l 203 451 l 704 451 l 704 510 l 203 510 l 203 915 l 744 915 l 744 972 l 135 972 z '
    },
    G: {
      ha: 983,
      x_min: 0,
      x_max: 0,
      o:
        'm 506 -19 b 883 358 742 -19 883 140 l 883 453 l 521 453 l 521 396 l 818 396 l 818 353 b 506 38 818 164 699 38 b 175 407 276 38 175 201 l 175 571 b 497 935 175 781 278 935 b 808 658 690 935 800 810 l 874 658 b 496 992 864 846 728 992 b 107 568 240 992 107 814 l 107 408 b 506 -19 107 174 238 -19 z '
    },
    H: {
      ha: 975,
      x_min: 0,
      x_max: 0,
      o: 'm 135 0 l 203 0 l 203 461 l 772 461 l 772 0 l 840 0 l 840 972 l 772 972 l 772 521 l 203 521 l 203 972 l 135 972 z '
    },
    I: { ha: 351, x_min: 0, x_max: 0, o: 'm 142 0 l 210 0 l 210 972 l 142 972 z ' },
    J: {
      ha: 807,
      x_min: 0,
      x_max: 0,
      o:
        'm 369 -19 b 676 254 549 -19 676 93 l 676 972 l 608 972 l 608 254 b 369 38 608 124 515 38 b 131 250 219 38 131 125 l 131 257 l 64 257 l 64 250 b 369 -19 64 93 185 -19 z '
    },
    K: {
      ha: 821,
      x_min: 0,
      x_max: 0,
      o: 'm 135 0 l 203 0 l 203 486 l 704 0 l 792 0 l 283 492 l 774 972 l 688 972 l 203 496 l 203 972 l 135 972 z '
    },
    L: { ha: 782, x_min: 0, x_max: 0, o: 'm 135 0 l 724 0 l 724 57 l 203 57 l 203 972 l 135 972 z ' },
    M: {
      ha: 1081,
      x_min: 0,
      x_max: 0,
      o: 'm 946 972 l 878 972 l 540 304 l 203 972 l 135 972 l 135 0 l 199 0 l 199 850 l 504 246 l 576 246 l 882 850 l 882 0 l 946 0 z '
    },
    N: { ha: 981, x_min: 0, x_max: 0, o: 'm 135 0 l 200 0 l 200 861 l 782 0 l 846 0 l 846 972 l 781 972 l 781 110 l 199 972 l 135 972 z ' },
    O: {
      ha: 1006,
      x_min: 0,
      x_max: 0,
      o:
        'm 899 569 b 503 992 899 799 771 992 b 107 569 235 992 107 799 l 107 403 b 503 -19 107 174 235 -19 b 899 403 771 -19 899 174 z m 832 400 b 503 36 832 206 731 36 b 174 400 275 36 174 206 l 174 572 b 503 936 174 767 275 936 b 832 572 731 936 832 767 z '
    },
    P: {
      ha: 876,
      x_min: 0,
      x_max: 0,
      o:
        'm 135 0 l 203 0 l 203 371 l 504 371 b 821 672 701 371 821 504 b 504 972 821 840 701 972 l 135 972 z m 203 428 l 203 915 l 497 915 b 753 672 672 915 753 801 b 497 428 753 543 672 428 z '
    },
    Q: {
      ha: 1006,
      x_min: 0,
      x_max: 0,
      o:
        'm 899 569 b 503 992 899 799 771 992 b 107 569 235 992 107 799 l 107 403 b 503 -19 107 174 235 -19 b 679 15 571 -19 629 -7 l 760 -119 l 807 -92 l 728 40 b 899 403 843 115 899 251 z m 832 400 b 697 93 832 274 789 158 l 622 219 l 575 193 l 650 65 b 503 36 608 47 560 36 b 174 400 275 36 174 206 l 174 572 b 503 936 174 767 275 936 b 832 572 731 936 832 767 z '
    },
    R: {
      ha: 925,
      x_min: 0,
      x_max: 0,
      o:
        'm 757 0 l 832 0 l 614 388 b 835 674 753 424 835 538 b 521 972 835 833 721 972 l 135 972 l 135 0 l 203 0 l 203 376 l 518 376 l 549 376 z m 203 432 l 203 917 l 510 917 b 767 674 681 917 767 806 b 508 432 767 542 682 432 z '
    },
    S: {
      ha: 906,
      x_min: 0,
      x_max: 0,
      o:
        'm 458 -19 b 813 258 654 -19 813 82 b 614 489 813 379 735 457 l 324 565 b 186 736 231 590 186 642 b 443 936 186 861 286 936 b 711 717 607 936 711 846 l 711 696 l 774 696 l 774 718 b 443 992 774 879 638 992 b 121 732 250 992 121 893 b 304 508 121 615 188 539 l 592 433 b 747 254 693 407 747 344 b 458 36 747 115 625 36 b 169 268 289 36 169 126 l 169 289 l 104 289 l 104 267 b 458 -19 104 94 256 -19 z '
    },
    T: { ha: 765, x_min: 0, x_max: 0, o: 'm 349 0 l 417 0 l 417 915 l 725 915 l 725 972 l 40 972 l 40 915 l 349 915 z ' },
    U: {
      ha: 981,
      x_min: 0,
      x_max: 0,
      o:
        'm 490 -19 b 851 317 711 -19 851 122 l 851 972 l 783 972 l 783 310 b 490 38 783 149 671 38 b 197 310 310 38 197 149 l 197 972 l 129 972 l 129 317 b 490 -19 129 122 269 -19 z '
    },
    V: { ha: 847, x_min: 0, x_max: 0, o: 'm 808 972 l 742 972 l 424 64 l 106 972 l 39 972 l 383 0 l 464 0 z ' },
    W: {
      ha: 1253,
      x_min: 0,
      x_max: 0,
      o: 'm 1200 972 l 1133 972 l 932 89 l 664 972 l 589 972 l 321 89 l 119 972 l 53 972 l 283 0 l 354 0 l 626 900 l 899 0 l 969 0 z '
    },
    X: {
      ha: 858,
      x_min: 0,
      x_max: 0,
      o: 'm 465 494 l 793 972 l 722 972 l 429 547 l 136 972 l 65 972 l 393 494 l 53 0 l 126 0 l 429 442 l 732 0 l 806 0 z '
    },
    Y: { ha: 808, x_min: 0, x_max: 0, o: 'm 438 376 l 786 972 l 715 972 l 404 439 l 93 972 l 22 972 l 371 376 l 371 0 l 438 0 z ' },
    Z: { ha: 856, x_min: 0, x_max: 0, o: 'm 94 0 l 764 0 l 764 57 l 167 57 l 747 915 l 747 972 l 121 972 l 121 915 l 675 915 l 94 57 z ' },
    '[': { ha: 490, x_min: 0, x_max: 0, o: 'm 128 -186 l 428 -186 l 428 -132 l 194 -132 l 194 1032 l 428 1032 l 428 1086 l 128 1086 z ' },
    '\\': { ha: 622, x_min: 0, x_max: 0, o: 'm 144 1042 l 81 1042 l 472 -146 l 536 -146 z ' },
    ']': { ha: 490, x_min: 0, x_max: 0, o: 'm 361 1086 l 61 1086 l 61 1032 l 294 1032 l 294 -132 l 61 -132 l 61 -186 l 361 -186 z ' },
    '^': { ha: 683, x_min: 0, x_max: 0, o: 'm 369 972 l 314 972 l 93 592 l 160 592 l 342 917 l 524 592 l 590 592 z ' },
    _: { ha: 676, x_min: 0, x_max: 0, o: 'm -1 -156 l 678 -156 l 678 -122 l -1 -122 z ' },
    '`': { ha: 469, x_min: 0, x_max: 0, o: 'm 215 999 l 136 999 l 267 810 l 333 810 z ' },
    a: {
      ha: 771,
      x_min: 0,
      x_max: 0,
      o:
        'm 344 -17 b 599 99 463 -17 561 39 l 599 0 l 663 0 l 663 465 b 394 722 663 611 554 722 b 125 538 263 722 158 654 l 188 538 b 394 668 221 618 290 668 b 596 463 519 668 596 579 l 596 322 b 356 428 557 374 465 428 b 72 210 190 428 72 347 b 344 -17 72 78 181 -17 z m 349 35 b 136 208 222 35 136 101 b 356 375 136 319 231 375 b 596 208 467 375 596 314 b 349 35 596 94 467 35 z '
    },
    b: {
      ha: 815,
      x_min: 0,
      x_max: 0,
      o:
        'm 121 1014 l 121 0 l 183 0 l 183 138 b 440 -17 219 51 310 -17 b 731 290 621 -17 731 115 l 731 415 b 440 722 731 590 621 722 b 188 575 314 722 225 657 l 188 1014 z m 664 294 b 429 38 664 149 585 38 b 188 297 292 38 188 150 l 188 408 b 428 668 188 556 290 668 b 664 411 582 668 664 557 z '
    },
    c: {
      ha: 774,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 686 240 561 -17 668 96 l 625 240 b 389 38 606 128 532 38 b 151 292 238 38 151 147 l 151 414 b 389 668 151 558 238 668 b 625 465 532 668 606 578 l 686 465 b 389 722 668 610 561 722 b 85 415 203 722 85 592 l 85 290 b 389 -17 85 114 203 -17 z '
    },
    d: {
      ha: 815,
      x_min: 0,
      x_max: 0,
      o:
        'm 628 1014 l 628 575 b 375 722 590 657 501 722 b 85 415 194 722 85 590 l 85 290 b 375 -17 85 115 194 -17 b 632 138 506 -17 596 51 l 632 0 l 694 0 l 694 1014 z m 151 411 b 388 668 151 557 233 668 b 628 408 525 668 628 556 l 628 297 b 386 38 628 150 524 38 b 151 294 231 38 151 149 z '
    },
    e: {
      ha: 768,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 667 196 532 -17 639 71 l 608 196 b 389 36 579 101 504 36 b 150 282 233 36 150 144 l 150 324 l 676 324 l 676 418 b 385 722 676 583 574 722 b 85 408 194 722 85 597 l 85 286 b 389 -17 85 106 201 -17 z m 150 411 b 385 669 150 565 226 669 b 613 421 536 669 613 560 l 613 378 l 150 378 z '
    },
    f: {
      ha: 478,
      x_min: 0,
      x_max: 0,
      o:
        'm 172 0 l 239 0 l 239 651 l 432 651 l 432 706 l 239 706 l 239 814 b 376 960 239 913 275 960 l 457 960 l 457 1014 l 372 1014 b 172 808 238 1014 172 950 l 172 706 l 63 706 l 63 651 l 172 651 z '
    },
    g: {
      ha: 813,
      x_min: 0,
      x_max: 0,
      o:
        'm 397 -258 b 692 -7 563 -258 692 -153 l 692 706 l 628 706 l 628 574 b 372 722 599 640 517 722 b 85 436 193 722 85 599 l 85 313 b 374 28 85 153 194 28 b 625 178 501 28 599 110 l 625 -6 b 397 -206 625 -128 536 -206 b 164 -92 297 -206 210 -168 l 97 -92 b 397 -258 144 -199 265 -258 z m 382 82 b 150 319 232 82 150 174 l 150 431 b 386 668 150 575 235 668 b 625 424 519 668 625 556 l 625 322 b 382 82 625 178 513 82 z '
    },
    h: {
      ha: 808,
      x_min: 0,
      x_max: 0,
      o:
        'm 121 0 l 188 0 l 188 411 b 421 665 188 576 293 665 b 628 435 560 665 628 578 l 628 0 l 694 0 l 694 443 b 436 722 694 618 593 722 b 188 569 307 722 226 663 l 188 1014 l 121 1014 z '
    },
    i: {
      ha: 322,
      x_min: 0,
      x_max: 0,
      o:
        'm 128 0 l 194 0 l 194 706 l 128 706 z m 108 914 b 161 863 108 889 128 863 b 214 914 194 863 214 889 b 161 965 214 942 194 965 b 108 914 128 965 108 942 z '
    },
    j: {
      ha: 322,
      x_min: 0,
      x_max: 0,
      o:
        'm -19 -242 l 33 -242 b 194 -86 140 -242 194 -187 l 194 706 l 128 706 l 128 -85 b 18 -187 128 -153 99 -187 l -19 -187 z m 108 914 b 161 863 108 889 128 863 b 214 914 194 863 214 889 b 161 965 214 942 194 965 b 108 914 128 965 108 942 z '
    },
    k: {
      ha: 688,
      x_min: 0,
      x_max: 0,
      o: 'm 121 0 l 188 0 l 188 361 l 553 0 l 642 0 l 268 367 l 625 706 l 536 706 l 188 372 l 188 1014 l 121 1014 z '
    },
    l: { ha: 322, x_min: 0, x_max: 0, o: 'm 128 0 l 194 0 l 194 1014 l 128 1014 z ' },
    m: {
      ha: 1299,
      x_min: 0,
      x_max: 0,
      o:
        'm 686 0 l 686 411 b 913 665 686 576 790 665 b 1118 435 1051 665 1118 578 l 1118 0 l 1185 0 l 1185 443 b 928 722 1185 618 1083 722 b 665 565 808 722 714 667 b 429 722 629 665 543 722 b 183 563 299 722 214 656 l 183 706 l 121 706 l 121 0 l 188 0 l 188 411 b 414 665 188 576 290 665 b 619 435 553 665 619 578 l 619 0 z '
    },
    n: {
      ha: 808,
      x_min: 0,
      x_max: 0,
      o:
        'm 121 0 l 188 0 l 188 411 b 421 665 188 576 293 665 b 628 435 560 665 628 578 l 628 0 l 694 0 l 694 443 b 436 722 694 618 593 722 b 183 563 301 722 215 656 l 183 706 l 121 706 z '
    },
    o: {
      ha: 778,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 693 290 581 -17 693 118 l 693 415 b 389 722 693 588 581 722 b 85 415 197 722 85 588 l 85 290 b 389 -17 85 118 197 -17 z m 629 413 l 629 293 b 389 38 629 147 543 38 b 149 293 235 38 149 147 l 149 413 b 389 668 149 558 235 668 b 629 413 543 668 629 558 z '
    },
    p: {
      ha: 815,
      x_min: 0,
      x_max: 0,
      o:
        'm 188 -242 l 188 131 b 440 -17 225 49 314 -17 b 731 290 621 -17 731 115 l 731 415 b 440 722 731 590 621 722 b 183 568 310 722 219 654 l 183 706 l 121 706 l 121 -242 z m 664 294 b 428 38 664 149 582 38 b 188 297 290 38 188 150 l 188 408 b 429 668 188 556 292 668 b 664 411 585 668 664 557 z '
    },
    q: {
      ha: 815,
      x_min: 0,
      x_max: 0,
      o:
        'm 694 -242 l 694 706 l 632 706 l 632 568 b 375 722 596 654 506 722 b 85 415 194 722 85 590 l 85 290 b 375 -17 85 115 194 -17 b 628 131 501 -17 590 49 l 628 -242 z m 151 411 b 386 668 151 557 231 668 b 628 408 524 668 628 556 l 628 297 b 388 38 628 150 525 38 b 151 294 233 38 151 149 z '
    },
    r: {
      ha: 475,
      x_min: 0,
      x_max: 0,
      o:
        'm 121 0 l 188 0 l 188 354 b 435 649 188 547 290 649 l 442 649 l 442 710 l 435 710 b 183 531 299 710 206 635 l 183 706 l 121 706 z '
    },
    s: {
      ha: 729,
      x_min: 0,
      x_max: 0,
      o:
        'm 372 -17 b 653 189 524 -17 653 64 b 496 363 653 279 601 336 l 267 419 b 171 528 204 435 171 468 b 360 668 171 617 243 668 b 551 504 481 668 551 601 l 551 500 l 617 500 l 617 504 b 360 722 617 633 511 722 b 106 528 208 722 106 647 b 254 360 106 439 160 383 l 486 303 b 588 188 556 286 588 246 b 374 38 588 94 493 38 b 151 203 251 38 151 99 l 151 206 l 86 206 l 86 201 b 372 -17 86 68 210 -17 z '
    },
    t: {
      ha: 508,
      x_min: 0,
      x_max: 0,
      o:
        'm 442 0 l 442 54 l 379 54 b 250 183 283 54 250 93 l 250 651 l 444 651 l 444 706 l 250 706 l 250 910 l 183 910 l 183 706 l 54 706 l 54 651 l 183 651 l 183 183 b 369 0 183 67 240 0 z '
    },
    u: {
      ha: 803,
      x_min: 0,
      x_max: 0,
      o:
        'm 682 706 l 615 706 l 615 294 b 385 40 615 129 513 40 b 181 271 246 40 181 128 l 181 706 l 114 706 l 114 263 b 369 -17 114 88 213 -17 b 619 143 504 -17 592 53 l 619 0 l 682 0 z '
    },
    v: { ha: 692, x_min: 0, x_max: 0, o: 'm 644 706 l 578 706 l 346 67 l 114 706 l 47 706 l 307 0 l 385 0 z ' },
    w: {
      ha: 1036,
      x_min: 0,
      x_max: 0,
      o: 'm 983 706 l 921 706 l 753 79 l 553 706 l 483 706 l 283 79 l 115 706 l 53 706 l 249 0 l 315 0 l 518 633 l 721 0 l 788 0 z '
    },
    x: {
      ha: 667,
      x_min: 0,
      x_max: 0,
      o: 'm 369 358 l 607 706 l 538 706 l 333 408 l 129 706 l 60 706 l 297 358 l 50 0 l 121 0 l 333 310 l 546 0 l 617 0 z '
    },
    y: { ha: 685, x_min: 0, x_max: 0, o: 'm 228 -242 l 293 -242 l 381 3 l 638 706 l 569 706 l 344 81 l 115 706 l 47 706 l 311 0 z ' },
    z: { ha: 682, x_min: 0, x_max: 0, o: 'm 83 0 l 606 0 l 606 56 l 157 56 l 600 653 l 600 706 l 101 706 l 101 650 l 526 650 l 83 53 z ' },
    '{': {
      ha: 588,
      x_min: 0,
      x_max: 0,
      o:
        'm 433 1086 b 236 897 303 1086 236 1010 l 236 621 b 92 478 236 532 188 478 l 49 478 l 49 422 l 92 422 b 236 279 188 422 236 368 l 236 3 b 433 -186 236 -110 303 -186 l 525 -186 l 525 -132 l 442 -132 b 303 7 346 -132 303 -82 l 303 286 b 181 450 303 372 267 432 b 303 614 267 468 303 528 l 303 893 b 442 1032 303 982 346 1032 l 525 1032 l 525 1086 z '
    },
    '|': { ha: 411, x_min: 0, x_max: 0, o: 'm 176 -208 l 235 -208 l 235 1111 l 176 1111 z ' },
    '}': {
      ha: 588,
      x_min: 0,
      x_max: 0,
      o:
        'm 63 1086 l 63 1032 l 146 1032 b 285 893 242 1032 285 982 l 285 614 b 407 450 285 528 321 468 b 285 286 321 432 285 372 l 285 7 b 146 -132 285 -82 242 -132 l 63 -132 l 63 -186 l 154 -186 b 351 3 285 -186 351 -110 l 351 279 b 496 422 351 368 400 422 l 539 422 l 539 478 l 496 478 b 351 621 400 478 351 532 l 351 897 b 154 1086 351 1010 285 1086 z '
    },
    '~': {
      ha: 814,
      x_min: 0,
      x_max: 0,
      o:
        'm 660 589 b 579 457 651 517 643 457 b 254 596 513 457 353 596 b 103 418 153 596 111 532 l 160 411 b 254 543 171 490 188 543 b 578 404 333 543 483 404 b 717 581 682 404 713 486 z '
    },
    ' ': { ha: 333, x_min: 0, x_max: 0, o: '' },
    '¡': {
      ha: 342,
      x_min: 0,
      x_max: 0,
      o:
        'm 186 761 l 153 761 l 136 444 l 136 0 l 206 0 l 206 444 z m 225 926 b 171 981 225 958 201 981 b 117 926 140 981 117 958 b 171 872 117 894 140 872 b 225 926 201 872 225 894 z '
    },
    '¢': {
      ha: 790,
      x_min: 0,
      x_max: 0,
      o:
        'm 368 0 l 433 0 l 433 140 b 683 360 572 151 667 246 l 622 360 b 403 193 606 267 525 193 b 172 431 265 193 172 279 l 172 542 b 403 779 172 693 265 779 b 622 613 525 779 606 706 l 683 613 b 435 832 667 726 572 822 l 435 972 l 369 972 l 369 832 b 107 543 215 821 107 711 l 107 429 b 368 140 107 261 215 154 z '
    },
    '£': {
      ha: 910,
      x_min: 0,
      x_max: 0,
      o:
        'm 108 0 l 775 0 l 775 56 l 347 56 l 347 436 l 653 436 l 653 492 l 347 492 l 347 711 b 553 938 347 854 408 938 b 757 738 683 938 757 851 l 757 718 l 819 718 l 819 738 b 553 992 819 882 722 992 b 281 710 376 992 281 893 l 281 492 l 129 492 l 129 436 l 281 436 l 281 56 l 108 56 z '
    },
    '¤': {
      ha: 817,
      x_min: 0,
      x_max: 0,
      o:
        'm 647 440 l 647 531 b 594 682 647 589 629 642 l 708 851 l 640 851 l 553 719 b 408 761 515 746 467 761 b 264 719 350 761 301 746 l 176 851 l 108 851 l 221 682 b 169 531 188 642 169 589 l 169 440 b 221 288 169 382 188 328 l 108 119 l 176 119 l 264 250 b 408 210 301 225 350 210 b 553 250 467 210 515 225 l 640 119 l 708 119 l 594 288 b 647 440 629 328 647 382 z m 408 258 b 226 439 286 258 226 338 l 226 532 b 408 713 226 633 286 713 b 590 532 531 713 590 633 l 590 439 b 408 258 590 338 531 258 z '
    },
    '¥': {
      ha: 789,
      x_min: 0,
      x_max: 0,
      o:
        'm 111 500 l 314 500 l 361 400 l 361 301 l 111 301 l 111 251 l 361 251 l 361 0 l 428 0 l 428 251 l 676 251 l 676 301 l 428 301 l 428 400 l 475 500 l 676 500 l 676 550 l 499 550 l 699 972 l 628 972 l 394 464 l 161 972 l 90 972 l 290 550 l 111 550 z '
    },
    '¦': { ha: 411, x_min: 0, x_max: 0, o: 'm 176 -208 l 235 -208 l 235 317 l 176 317 z m 176 586 l 235 586 l 235 1111 l 176 1111 z ' },
    '§': {
      ha: 836,
      x_min: 0,
      x_max: 0,
      o:
        'm 417 -172 b 674 36 563 -172 674 -83 b 628 161 674 90 657 129 b 728 354 675 203 728 274 b 600 533 728 433 689 496 l 342 642 b 229 783 278 668 229 707 b 424 942 229 883 306 942 b 632 772 560 942 632 875 l 632 756 l 689 756 l 689 772 b 424 992 689 907 588 992 b 169 782 268 992 169 906 b 226 649 169 721 192 679 b 114 460 175 619 114 551 b 263 272 114 363 171 308 l 503 178 b 614 35 575 150 614 106 b 417 -122 614 -64 528 -122 b 210 47 283 -122 210 -51 l 210 63 l 150 63 l 150 46 b 417 -172 150 -87 260 -172 z m 514 231 l 288 319 b 172 461 208 350 172 392 b 265 621 172 536 215 585 b 331 589 286 608 307 599 l 576 485 b 669 354 646 456 669 413 b 589 192 669 289 633 235 b 514 231 567 207 542 219 z '
    },
    '¨': {
      ha: 656,
      x_min: 0,
      x_max: 0,
      o:
        'm 136 897 b 188 847 136 872 156 847 b 239 897 219 847 239 872 b 188 947 239 924 219 947 b 136 897 156 947 136 924 z m 417 897 b 468 847 417 872 436 847 b 519 897 500 847 519 872 b 468 947 519 924 500 947 b 417 897 436 947 417 924 z '
    },
    '©': {
      ha: 1211,
      x_min: 0,
      x_max: 0,
      o:
        'm 606 989 b 107 486 301 989 107 757 b 606 -17 107 215 301 -17 b 1104 486 910 -17 1104 215 b 606 989 1104 757 910 989 z m 606 11 b 138 486 314 11 138 231 b 606 961 138 742 314 961 b 1074 486 897 961 1074 742 b 606 11 1074 231 897 11 z m 454 444 l 454 528 b 608 701 454 628 504 701 b 753 578 696 701 742 646 l 794 578 b 608 739 785 664 717 739 b 411 529 478 739 411 643 l 411 443 b 608 233 411 329 478 233 b 794 394 717 233 785 308 l 753 394 b 608 271 742 326 696 271 b 454 444 504 271 454 344 z '
    },
    ª: {
      ha: 586,
      x_min: 0,
      x_max: 0,
      o:
        'm 97 379 l 483 379 l 483 418 l 97 418 z m 275 518 b 431 588 350 518 410 556 l 431 529 l 476 529 l 476 822 b 304 985 476 911 406 985 b 136 867 219 985 157 940 l 179 867 b 304 944 200 915 238 944 b 429 815 383 944 429 886 l 429 739 b 278 803 406 771 347 803 b 100 663 172 803 100 751 b 275 518 100 582 167 518 z m 279 556 b 147 663 206 556 147 596 b 281 765 147 732 207 765 b 429 661 350 765 429 729 b 279 556 429 594 351 556 z '
    },
    '«': {
      ha: 814,
      x_min: 0,
      x_max: 0,
      o: 'm 304 83 l 379 83 l 135 375 l 379 667 l 304 667 l 58 375 z m 653 83 l 728 83 l 483 375 l 728 667 l 653 667 l 407 375 z '
    },
    '¬': { ha: 817, x_min: 0, x_max: 0, o: 'm 639 181 l 699 181 l 699 526 l 90 526 l 90 474 l 639 474 z ' },
    '®': {
      ha: 743,
      x_min: 0,
      x_max: 0,
      o:
        'm 371 406 b 667 697 549 406 667 536 b 371 989 667 857 549 989 b 76 697 193 989 76 857 b 371 406 76 536 193 406 z m 371 424 b 97 697 201 424 97 550 b 371 971 97 844 201 971 b 646 697 540 971 646 844 b 371 424 646 550 540 424 z m 449 572 l 482 572 l 424 672 b 486 753 461 682 486 713 b 400 838 486 796 456 838 l 285 838 l 285 572 l 314 572 l 314 669 l 394 669 z m 314 693 l 314 814 l 390 814 b 457 753 436 814 457 785 b 390 693 457 721 438 693 z '
    },
    '¯': { ha: 676, x_min: 0, x_max: 0, o: 'm 136 871 l 540 871 l 540 924 l 136 924 z ' },
    '°': {
      ha: 553,
      x_min: 0,
      x_max: 0,
      o:
        'm 276 988 b 76 786 142 988 76 886 b 276 585 76 686 142 585 b 476 786 411 585 476 686 b 276 988 476 886 411 988 z m 276 621 b 118 786 169 621 118 704 b 276 951 118 868 169 951 b 435 786 383 951 435 868 b 276 621 435 704 383 621 z '
    },
    '±': {
      ha: 858,
      x_min: 0,
      x_max: 0,
      o:
        'm 125 0 l 733 0 l 733 51 l 125 51 z m 400 211 l 458 211 l 458 489 l 733 489 l 733 542 l 458 542 l 458 819 l 400 819 l 400 542 l 125 542 l 125 489 l 400 489 z '
    },
    '²': {
      ha: 575,
      x_min: 0,
      x_max: 0,
      o:
        'm 111 649 l 457 649 l 457 692 l 175 692 l 388 888 b 464 1026 431 928 464 967 b 294 1172 464 1110 396 1172 b 122 1017 190 1172 122 1114 l 122 1004 l 169 1004 l 169 1015 b 293 1129 169 1088 214 1129 b 413 1026 367 1129 413 1085 b 356 921 413 983 385 949 l 111 689 z '
    },
    '³': {
      ha: 576,
      x_min: 0,
      x_max: 0,
      o:
        'm 282 640 b 465 796 385 640 465 704 b 299 940 465 881 394 940 l 275 940 l 447 1122 l 447 1163 l 150 1163 l 150 1122 l 388 1122 l 215 940 l 215 900 l 285 900 b 415 793 367 900 415 858 b 283 681 415 728 361 681 b 150 788 214 681 160 718 l 104 788 b 282 640 114 696 192 640 z '
    },
    '´': { ha: 469, x_min: 0, x_max: 0, o: 'm 136 810 l 203 810 l 333 999 l 254 999 z ' },
    µ: {
      ha: 810,
      x_min: 0,
      x_max: 0,
      o:
        'm 689 706 l 622 706 l 622 294 b 392 40 622 129 519 40 b 188 260 256 40 188 124 l 188 706 l 121 706 l 121 -242 l 188 -242 l 188 82 b 376 -17 219 21 290 -17 b 626 143 511 -17 599 53 l 626 0 l 689 0 z '
    },
    '¶': {
      ha: 789,
      x_min: 0,
      x_max: 0,
      o: 'm 597 -242 l 647 -242 l 647 972 l 440 972 b 86 629 210 972 86 838 b 442 288 86 421 215 288 l 442 929 l 597 929 z '
    },
    '·': {
      ha: 308,
      x_min: 0,
      x_max: 0,
      o: 'm 100 408 b 154 354 100 376 124 354 b 208 408 185 354 208 376 b 154 463 208 440 185 463 b 100 408 124 463 100 440 z '
    },
    '¸': {
      ha: 492,
      x_min: 0,
      x_max: 0,
      o:
        'm 228 -258 b 356 -162 303 -258 356 -225 b 249 -74 356 -107 308 -76 l 222 -72 l 233 0 l 186 0 l 165 -111 l 226 -115 b 303 -165 271 -118 303 -133 b 219 -214 303 -201 272 -214 b 136 -206 192 -214 163 -211 l 136 -250 b 228 -258 165 -256 200 -258 z '
    },
    '¹': { ha: 406, x_min: 0, x_max: 0, o: 'm 208 649 l 260 649 l 260 1163 l 215 1163 l 90 1106 l 90 1058 l 208 1111 z ' },
    º: {
      ha: 614,
      x_min: 0,
      x_max: 0,
      o:
        'm 122 379 l 492 379 l 492 418 l 122 418 z m 506 781 b 307 985 506 896 433 985 b 108 781 181 985 108 896 l 108 722 b 307 518 108 607 181 518 b 506 722 433 518 506 607 z m 460 722 b 307 557 460 631 407 557 b 154 722 207 557 154 631 l 154 781 b 307 946 154 872 207 946 b 460 781 407 946 460 872 z '
    },
    '»': {
      ha: 814,
      x_min: 0,
      x_max: 0,
      o: 'm 756 375 l 510 667 l 435 667 l 679 375 l 435 83 l 510 83 z m 407 375 l 161 667 l 86 667 l 331 375 l 86 83 l 161 83 z '
    },
    '¼': {
      ha: 1083,
      x_min: 0,
      x_max: 0,
      o:
        'm 861 0 l 910 0 l 910 122 l 981 122 l 981 165 l 910 165 l 910 282 l 861 282 l 861 165 l 650 165 l 825 514 l 775 514 l 596 164 l 596 122 l 861 122 z m 225 458 l 276 458 l 276 972 l 232 972 l 107 915 l 107 868 l 225 921 z m 229 0 l 283 0 l 790 972 l 736 972 z '
    },
    '½': {
      ha: 1113,
      x_min: 0,
      x_max: 0,
      o:
        'm 654 0 l 1000 0 l 1000 43 l 718 43 l 931 239 b 1007 378 974 279 1007 318 b 838 524 1007 461 939 524 b 665 368 733 524 665 465 l 665 356 l 713 356 l 713 367 b 836 481 713 439 757 481 b 956 378 910 481 956 436 b 899 272 956 335 928 300 l 654 40 z m 225 458 l 276 458 l 276 972 l 232 972 l 107 915 l 107 868 l 225 921 z m 229 0 l 283 0 l 790 972 l 736 972 z '
    },
    '¾': {
      ha: 1185,
      x_min: 0,
      x_max: 0,
      o:
        'm 292 450 b 475 606 394 450 475 514 b 308 750 475 690 404 750 l 285 750 l 457 932 l 457 972 l 160 972 l 160 932 l 397 932 l 225 750 l 225 710 l 294 710 b 425 603 376 710 425 668 b 293 490 425 538 371 490 b 160 597 224 490 169 528 l 114 597 b 292 450 124 506 201 450 z m 963 0 l 1011 0 l 1011 122 l 1082 122 l 1082 165 l 1011 165 l 1011 282 l 963 282 l 963 165 l 751 165 l 926 514 l 876 514 l 697 164 l 697 122 l 963 122 z m 331 0 l 385 0 l 892 972 l 838 972 z '
    },
    '¿': {
      ha: 689,
      x_min: 0,
      x_max: 0,
      o:
        'm 418 751 l 357 751 l 357 668 b 254 465 357 558 332 524 l 188 415 b 76 210 117 363 76 289 b 353 -19 76 76 188 -19 b 617 226 511 -19 617 74 l 617 250 l 556 250 l 556 228 b 353 35 556 104 476 35 b 143 210 225 35 143 107 b 247 386 143 286 181 336 l 307 431 b 418 668 393 494 418 547 z m 438 926 b 383 981 438 958 414 981 b 329 926 353 981 329 958 b 383 872 329 894 353 872 b 438 926 414 872 438 894 z '
    },
    À: {
      ha: 919,
      x_min: 0,
      x_max: 0,
      o:
        'm 494 972 l 425 972 l 56 0 l 126 0 l 224 267 l 694 267 l 793 0 l 864 0 z m 460 908 l 674 324 l 244 324 z m 418 1060 l 485 1060 l 382 1225 l 301 1225 z '
    },
    Á: {
      ha: 919,
      x_min: 0,
      x_max: 0,
      o:
        'm 494 972 l 425 972 l 56 0 l 126 0 l 224 267 l 694 267 l 793 0 l 864 0 z m 460 908 l 674 324 l 244 324 z m 440 1060 l 507 1060 l 624 1225 l 543 1225 z '
    },
    Â: {
      ha: 919,
      x_min: 0,
      x_max: 0,
      o:
        'm 494 972 l 425 972 l 56 0 l 126 0 l 224 267 l 694 267 l 793 0 l 864 0 z m 460 908 l 674 324 l 244 324 z m 492 1225 l 428 1225 l 269 1060 l 338 1060 l 460 1188 l 582 1060 l 650 1060 z '
    },
    Ã: {
      ha: 919,
      x_min: 0,
      x_max: 0,
      o:
        'm 494 972 l 425 972 l 56 0 l 126 0 l 224 267 l 694 267 l 793 0 l 864 0 z m 460 908 l 674 324 l 244 324 z m 265 1065 b 344 1168 276 1121 290 1168 b 585 1069 414 1168 515 1069 b 703 1208 661 1069 688 1143 l 657 1221 b 583 1118 639 1161 631 1118 b 344 1217 529 1118 429 1217 b 218 1074 263 1217 233 1158 z '
    },
    Ä: {
      ha: 919,
      x_min: 0,
      x_max: 0,
      o:
        'm 494 972 l 425 972 l 56 0 l 126 0 l 224 267 l 694 267 l 793 0 l 864 0 z m 460 908 l 674 324 l 244 324 z m 253 1135 b 304 1085 253 1110 272 1085 b 356 1135 336 1085 356 1110 b 304 1185 356 1161 336 1185 b 253 1135 272 1185 253 1161 z m 564 1135 b 615 1085 564 1110 583 1085 b 667 1135 647 1085 667 1110 b 615 1185 667 1161 647 1185 b 564 1135 583 1185 564 1161 z '
    },
    Å: {
      ha: 919,
      x_min: 0,
      x_max: 0,
      o:
        'm 126 0 l 224 267 l 694 267 l 793 0 l 864 0 l 506 942 b 579 1046 551 958 579 999 b 460 1157 579 1107 533 1157 b 340 1046 386 1157 340 1107 b 414 942 340 999 368 958 l 56 0 z m 460 908 l 674 324 l 244 324 z m 460 972 b 383 1046 411 972 383 1004 b 460 1119 383 1088 411 1119 b 536 1046 508 1119 536 1088 b 460 972 536 1004 508 972 z '
    },
    Æ: {
      ha: 1426,
      x_min: 0,
      x_max: 0,
      o:
        'm 721 0 l 1346 0 l 1346 57 l 789 57 l 789 464 l 1304 464 l 1304 522 l 789 522 l 789 915 l 1344 915 l 1344 972 l 690 972 l 24 0 l 97 0 l 285 276 l 721 276 z m 322 332 l 721 917 l 721 332 z '
    },
    Ç: {
      ha: 971,
      x_min: 0,
      x_max: 0,
      o:
        'm 504 -258 b 632 -162 579 -258 632 -225 b 525 -74 632 -107 585 -76 l 499 -72 l 507 -19 b 874 310 721 -15 857 132 l 808 310 b 497 38 789 163 685 38 b 175 397 283 38 175 190 l 175 575 b 497 935 175 782 283 935 b 808 663 685 935 789 810 l 874 663 b 499 992 857 842 718 992 b 107 574 240 992 107 811 l 107 399 b 458 -18 107 174 226 0 l 442 -111 l 503 -115 b 579 -165 547 -118 579 -133 b 496 -214 579 -201 549 -214 b 413 -206 468 -214 439 -211 l 413 -250 b 504 -258 442 -256 476 -258 z '
    },
    È: {
      ha: 840,
      x_min: 0,
      x_max: 0,
      o:
        'm 135 0 l 760 0 l 760 57 l 203 57 l 203 464 l 718 464 l 718 522 l 203 522 l 203 915 l 758 915 l 758 972 l 135 972 z m 424 1060 l 490 1060 l 388 1225 l 307 1225 z '
    },
    É: {
      ha: 840,
      x_min: 0,
      x_max: 0,
      o:
        'm 135 0 l 760 0 l 760 57 l 203 57 l 203 464 l 718 464 l 718 522 l 203 522 l 203 915 l 758 915 l 758 972 l 135 972 z m 400 1060 l 467 1060 l 583 1225 l 503 1225 z '
    },
    Ê: {
      ha: 840,
      x_min: 0,
      x_max: 0,
      o:
        'm 135 0 l 760 0 l 760 57 l 203 57 l 203 464 l 718 464 l 718 522 l 203 522 l 203 915 l 758 915 l 758 972 l 135 972 z m 482 1225 l 418 1225 l 260 1060 l 328 1060 l 450 1188 l 572 1060 l 640 1060 z '
    },
    Ë: {
      ha: 840,
      x_min: 0,
      x_max: 0,
      o:
        'm 135 0 l 760 0 l 760 57 l 203 57 l 203 464 l 718 464 l 718 522 l 203 522 l 203 915 l 758 915 l 758 972 l 135 972 z m 243 1135 b 294 1085 243 1110 263 1085 b 346 1135 326 1085 346 1110 b 294 1185 346 1161 326 1185 b 243 1135 263 1185 243 1161 z m 554 1135 b 606 1085 554 1110 574 1085 b 657 1135 638 1085 657 1110 b 606 1185 657 1161 638 1185 b 554 1135 574 1185 554 1161 z '
    },
    Ì: { ha: 351, x_min: 0, x_max: 0, o: 'm 142 0 l 210 0 l 210 972 l 142 972 z m 136 1060 l 203 1060 l 100 1225 l 19 1225 z ' },
    Í: { ha: 351, x_min: 0, x_max: 0, o: 'm 142 0 l 210 0 l 210 972 l 142 972 z m 149 1060 l 215 1060 l 332 1225 l 251 1225 z ' },
    Î: {
      ha: 351,
      x_min: 0,
      x_max: 0,
      o: 'm 142 0 l 210 0 l 210 972 l 142 972 z m 207 1225 l 143 1225 l -15 1060 l 53 1060 l 175 1188 l 297 1060 l 365 1060 z '
    },
    Ï: {
      ha: 351,
      x_min: 0,
      x_max: 0,
      o:
        'm 142 0 l 210 0 l 210 972 l 142 972 z m -32 1135 b 19 1085 -32 1110 -12 1085 b 71 1135 51 1085 71 1110 b 19 1185 71 1161 51 1185 b -32 1135 -12 1185 -32 1161 z m 279 1135 b 331 1085 279 1110 299 1085 b 382 1135 363 1085 382 1110 b 331 1185 382 1161 363 1185 b 279 1135 299 1185 279 1161 z '
    },
    Ð: {
      ha: 1014,
      x_min: 0,
      x_max: 0,
      o:
        'm 63 460 l 181 460 l 181 0 l 526 0 b 910 374 774 0 910 164 l 910 599 b 526 972 910 808 774 972 l 181 972 l 181 513 l 63 513 z m 842 597 l 842 375 b 518 57 842 186 726 57 l 249 57 l 249 460 l 528 460 l 528 513 l 249 513 l 249 915 l 518 915 b 842 597 726 915 842 786 z '
    },
    Ñ: {
      ha: 981,
      x_min: 0,
      x_max: 0,
      o:
        'm 135 0 l 200 0 l 200 861 l 782 0 l 846 0 l 846 972 l 781 972 l 781 110 l 199 972 l 135 972 z m 300 1065 b 379 1168 311 1121 325 1168 b 619 1069 449 1168 550 1069 b 738 1208 696 1069 722 1143 l 692 1221 b 618 1118 674 1161 665 1118 b 379 1217 564 1118 464 1217 b 253 1074 297 1217 268 1158 z '
    },
    Ò: {
      ha: 1006,
      x_min: 0,
      x_max: 0,
      o:
        'm 899 569 b 503 992 899 799 771 992 b 107 569 235 992 107 799 l 107 403 b 503 -19 107 174 235 -19 b 899 403 771 -19 899 174 z m 832 400 b 503 36 832 206 731 36 b 174 400 275 36 174 206 l 174 572 b 503 936 174 767 275 936 b 832 572 731 936 832 767 z m 461 1060 l 528 1060 l 425 1225 l 344 1225 z '
    },
    Ó: {
      ha: 1006,
      x_min: 0,
      x_max: 0,
      o:
        'm 899 569 b 503 992 899 799 771 992 b 107 569 235 992 107 799 l 107 403 b 503 -19 107 174 235 -19 b 899 403 771 -19 899 174 z m 832 400 b 503 36 832 206 731 36 b 174 400 275 36 174 206 l 174 572 b 503 936 174 767 275 936 b 832 572 731 936 832 767 z m 467 1060 l 533 1060 l 650 1225 l 569 1225 z '
    },
    Ô: {
      ha: 1006,
      x_min: 0,
      x_max: 0,
      o:
        'm 899 569 b 503 992 899 799 771 992 b 107 569 235 992 107 799 l 107 403 b 503 -19 107 174 235 -19 b 899 403 771 -19 899 174 z m 832 400 b 503 36 832 206 731 36 b 174 400 275 36 174 206 l 174 572 b 503 936 174 767 275 936 b 832 572 731 936 832 767 z m 535 1225 l 471 1225 l 313 1060 l 381 1060 l 503 1188 l 625 1060 l 693 1060 z '
    },
    Õ: {
      ha: 1006,
      x_min: 0,
      x_max: 0,
      o:
        'm 899 569 b 503 992 899 799 771 992 b 107 569 235 992 107 799 l 107 403 b 503 -19 107 174 235 -19 b 899 403 771 -19 899 174 z m 832 400 b 503 36 832 206 731 36 b 174 400 275 36 174 206 l 174 572 b 503 936 174 767 275 936 b 832 572 731 936 832 767 z m 313 1065 b 392 1168 324 1121 338 1168 b 632 1069 461 1168 563 1069 b 750 1208 708 1069 735 1143 l 704 1221 b 631 1118 686 1161 678 1118 b 392 1217 576 1118 476 1217 b 265 1074 310 1217 281 1158 z '
    },
    Ö: {
      ha: 1006,
      x_min: 0,
      x_max: 0,
      o:
        'm 899 569 b 503 992 899 799 771 992 b 107 569 235 992 107 799 l 107 403 b 503 -19 107 174 235 -19 b 899 403 771 -19 899 174 z m 832 400 b 503 36 832 206 731 36 b 174 400 275 36 174 206 l 174 572 b 503 936 174 767 275 936 b 832 572 731 936 832 767 z m 296 1135 b 347 1085 296 1110 315 1085 b 399 1135 379 1085 399 1110 b 347 1185 399 1161 379 1185 b 296 1135 315 1185 296 1161 z m 607 1135 b 658 1085 607 1110 626 1085 b 710 1135 690 1085 710 1110 b 658 1185 710 1161 690 1185 b 607 1135 626 1185 607 1161 z '
    },
    '×': {
      ha: 779,
      x_min: 0,
      x_max: 0,
      o: 'm 157 229 l 389 461 l 622 229 l 661 269 l 428 500 l 661 733 l 622 772 l 389 540 l 157 772 l 118 733 l 350 500 l 118 269 z '
    },
    Ø: {
      ha: 1006,
      x_min: 0,
      x_max: 0,
      o:
        'm 899 569 b 790 878 899 690 863 800 l 899 1042 l 840 1042 l 754 911 b 503 992 692 961 608 992 b 107 569 235 992 107 799 l 107 403 b 214 94 107 282 142 172 l 107 -69 l 165 -69 l 251 60 b 503 -19 314 10 397 -19 b 899 403 771 -19 899 174 z m 832 400 b 503 36 832 206 731 36 b 285 111 410 36 338 64 l 754 824 b 832 572 807 757 832 672 z m 174 400 l 174 572 b 503 936 174 767 275 936 b 721 861 596 936 668 907 l 250 149 b 174 400 197 215 174 300 z '
    },
    Ù: {
      ha: 981,
      x_min: 0,
      x_max: 0,
      o:
        'm 490 -19 b 851 317 711 -19 851 122 l 851 972 l 783 972 l 783 310 b 490 38 783 149 671 38 b 197 310 310 38 197 149 l 197 972 l 129 972 l 129 317 b 490 -19 129 122 269 -19 z m 476 1060 l 543 1060 l 440 1225 l 360 1225 z '
    },
    Ú: {
      ha: 981,
      x_min: 0,
      x_max: 0,
      o:
        'm 490 -19 b 851 317 711 -19 851 122 l 851 972 l 783 972 l 783 310 b 490 38 783 149 671 38 b 197 310 310 38 197 149 l 197 972 l 129 972 l 129 317 b 490 -19 129 122 269 -19 z m 436 1060 l 503 1060 l 619 1225 l 539 1225 z '
    },
    Û: {
      ha: 981,
      x_min: 0,
      x_max: 0,
      o:
        'm 490 -19 b 851 317 711 -19 851 122 l 851 972 l 783 972 l 783 310 b 490 38 783 149 671 38 b 197 310 310 38 197 149 l 197 972 l 129 972 l 129 317 b 490 -19 129 122 269 -19 z m 522 1225 l 458 1225 l 300 1060 l 368 1060 l 490 1188 l 613 1060 l 681 1060 z '
    },
    Ü: {
      ha: 981,
      x_min: 0,
      x_max: 0,
      o:
        'm 490 -19 b 851 317 711 -19 851 122 l 851 972 l 783 972 l 783 310 b 490 38 783 149 671 38 b 197 310 310 38 197 149 l 197 972 l 129 972 l 129 317 b 490 -19 129 122 269 -19 z m 283 1135 b 335 1085 283 1110 303 1085 b 386 1135 367 1085 386 1110 b 335 1185 386 1161 367 1185 b 283 1135 303 1185 283 1161 z m 594 1135 b 646 1085 594 1110 614 1085 b 697 1135 678 1085 697 1110 b 646 1185 697 1161 678 1185 b 594 1135 614 1185 594 1161 z '
    },
    Ý: {
      ha: 808,
      x_min: 0,
      x_max: 0,
      o:
        'm 438 376 l 786 972 l 715 972 l 404 439 l 93 972 l 22 972 l 371 376 l 371 0 l 438 0 z m 369 1060 l 436 1060 l 553 1225 l 472 1225 z '
    },
    Þ: {
      ha: 876,
      x_min: 0,
      x_max: 0,
      o:
        'm 135 0 l 203 0 l 203 193 l 504 193 b 821 494 701 193 821 326 b 504 794 821 663 701 794 l 203 794 l 203 972 l 135 972 z m 203 250 l 203 738 l 497 738 b 753 494 672 738 753 624 b 497 250 753 365 672 250 z '
    },
    ß: {
      ha: 821,
      x_min: 0,
      x_max: 0,
      o:
        'm 121 0 l 188 0 l 188 754 b 404 965 188 904 283 965 b 625 756 539 965 625 875 b 403 538 625 646 547 547 l 403 483 l 438 483 b 681 268 579 483 681 394 b 454 54 681 135 588 54 l 403 54 l 403 0 l 457 0 b 746 265 624 0 746 106 b 519 517 746 413 639 501 b 690 760 624 557 690 644 b 404 1019 690 908 578 1019 b 121 753 236 1019 121 925 z '
    },
    à: {
      ha: 771,
      x_min: 0,
      x_max: 0,
      o:
        'm 344 -17 b 599 99 463 -17 561 39 l 599 0 l 663 0 l 663 465 b 394 722 663 611 554 722 b 125 538 263 722 158 654 l 188 538 b 394 668 221 618 290 668 b 596 463 519 668 596 579 l 596 322 b 356 428 557 374 465 428 b 72 210 190 428 72 347 b 344 -17 72 78 181 -17 z m 349 35 b 136 208 222 35 136 101 b 356 375 136 319 231 375 b 596 208 467 375 596 314 b 349 35 596 94 467 35 z m 311 999 l 232 999 l 363 810 l 429 810 z '
    },
    á: {
      ha: 771,
      x_min: 0,
      x_max: 0,
      o:
        'm 344 -17 b 599 99 463 -17 561 39 l 599 0 l 663 0 l 663 465 b 394 722 663 611 554 722 b 125 538 263 722 158 654 l 188 538 b 394 668 221 618 290 668 b 596 463 519 668 596 579 l 596 322 b 356 428 557 374 465 428 b 72 210 190 428 72 347 b 344 -17 72 78 181 -17 z m 349 35 b 136 208 222 35 136 101 b 356 375 136 319 231 375 b 596 208 467 375 596 314 b 349 35 596 94 467 35 z m 356 810 l 422 810 l 553 999 l 474 999 z '
    },
    â: {
      ha: 771,
      x_min: 0,
      x_max: 0,
      o:
        'm 344 -17 b 599 99 463 -17 561 39 l 599 0 l 663 0 l 663 465 b 394 722 663 611 554 722 b 125 538 263 722 158 654 l 188 538 b 394 668 221 618 290 668 b 596 463 519 668 596 579 l 596 322 b 356 428 557 374 465 428 b 72 210 190 428 72 347 b 344 -17 72 78 181 -17 z m 349 35 b 136 208 222 35 136 101 b 356 375 136 319 231 375 b 596 208 467 375 596 314 b 349 35 596 94 467 35 z m 431 999 l 367 999 l 214 810 l 279 810 l 399 957 l 518 810 l 583 810 z '
    },
    ã: {
      ha: 771,
      x_min: 0,
      x_max: 0,
      o:
        'm 344 -17 b 599 99 463 -17 561 39 l 599 0 l 663 0 l 663 465 b 394 722 663 611 554 722 b 125 538 263 722 158 654 l 188 538 b 394 668 221 618 290 668 b 596 463 519 668 596 579 l 596 322 b 356 428 557 374 465 428 b 72 210 190 428 72 347 b 344 -17 72 78 181 -17 z m 349 35 b 136 208 222 35 136 101 b 356 375 136 319 231 375 b 596 208 467 375 596 314 b 349 35 596 94 467 35 z m 217 821 b 296 925 231 878 243 925 b 515 826 364 925 447 826 b 632 967 592 826 617 900 l 585 976 b 515 874 574 928 564 874 b 294 972 461 874 379 972 b 169 831 215 972 182 910 z '
    },
    ä: {
      ha: 771,
      x_min: 0,
      x_max: 0,
      o:
        'm 344 -17 b 599 99 463 -17 561 39 l 599 0 l 663 0 l 663 465 b 394 722 663 611 554 722 b 125 538 263 722 158 654 l 188 538 b 394 668 221 618 290 668 b 596 463 519 668 596 579 l 596 322 b 356 428 557 374 465 428 b 72 210 190 428 72 347 b 344 -17 72 78 181 -17 z m 349 35 b 136 208 222 35 136 101 b 356 375 136 319 231 375 b 596 208 467 375 596 314 b 349 35 596 94 467 35 z m 210 897 b 261 847 210 872 229 847 b 313 897 293 847 313 872 b 261 947 313 924 293 947 b 210 897 229 947 210 924 z m 490 897 b 542 847 490 872 510 847 b 593 897 574 847 593 872 b 542 947 593 924 574 947 b 490 897 510 947 490 924 z '
    },
    å: {
      ha: 771,
      x_min: 0,
      x_max: 0,
      o:
        'm 344 -17 b 599 99 463 -17 561 39 l 599 0 l 663 0 l 663 465 b 394 722 663 611 554 722 b 125 538 263 722 158 654 l 188 538 b 394 668 221 618 290 668 b 596 463 519 668 596 579 l 596 322 b 356 428 557 374 465 428 b 72 210 190 428 72 347 b 344 -17 72 78 181 -17 z m 349 35 b 136 208 222 35 136 101 b 356 375 136 319 231 375 b 596 208 467 375 596 314 b 349 35 596 94 467 35 z m 399 847 b 322 921 350 847 322 879 b 399 994 322 963 350 994 b 475 921 447 994 475 963 b 399 847 475 879 447 847 z m 399 810 b 518 921 472 810 518 860 b 399 1032 518 982 472 1032 b 279 921 325 1032 279 982 b 399 810 279 860 325 810 z '
    },
    æ: {
      ha: 1281,
      x_min: 0,
      x_max: 0,
      o:
        'm 901 -17 b 1179 196 1044 -17 1151 71 l 1121 196 b 901 36 1092 101 1017 36 b 663 282 746 36 663 144 l 663 324 l 1189 324 l 1189 418 b 897 722 1189 583 1086 722 b 635 578 772 722 682 668 b 393 722 594 661 508 722 b 126 536 257 722 161 656 l 188 536 b 393 668 221 619 283 668 b 596 461 518 668 596 572 l 596 332 b 356 431 556 383 461 431 b 72 211 188 431 72 350 b 356 -17 72 86 174 -17 b 632 131 490 -17 596 51 b 901 -17 681 39 775 -17 z m 351 35 b 136 210 225 35 136 103 b 354 378 136 324 232 378 b 596 213 465 378 596 319 b 351 35 596 101 479 35 z m 663 411 b 897 669 663 565 739 669 b 1125 421 1049 669 1125 560 l 1125 378 l 663 378 z '
    },
    ç: {
      ha: 774,
      x_min: 0,
      x_max: 0,
      o:
        'm 394 -258 b 522 -162 469 -258 522 -225 b 415 -74 522 -107 475 -76 l 389 -72 l 397 -17 b 686 240 564 -12 668 97 l 625 240 b 389 38 606 128 532 38 b 151 292 238 38 151 147 l 151 414 b 389 668 151 558 238 668 b 625 465 532 668 606 578 l 686 465 b 389 722 668 610 561 722 b 85 415 203 722 85 592 l 85 290 b 350 -14 85 126 186 1 l 332 -111 l 393 -115 b 469 -165 438 -118 469 -133 b 386 -214 469 -201 439 -214 b 303 -206 358 -214 329 -211 l 303 -250 b 394 -258 332 -256 367 -258 z '
    },
    è: {
      ha: 768,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 667 196 532 -17 639 71 l 608 196 b 389 36 579 101 504 36 b 150 282 233 36 150 144 l 150 324 l 676 324 l 676 418 b 385 722 676 583 574 722 b 85 408 194 722 85 597 l 85 286 b 389 -17 85 106 201 -17 z m 150 411 b 385 669 150 565 226 669 b 613 421 536 669 613 560 l 613 378 l 150 378 z m 297 999 l 218 999 l 349 810 l 415 810 z '
    },
    é: {
      ha: 768,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 667 196 532 -17 639 71 l 608 196 b 389 36 579 101 504 36 b 150 282 233 36 150 144 l 150 324 l 676 324 l 676 418 b 385 722 676 583 574 722 b 85 408 194 722 85 597 l 85 286 b 389 -17 85 106 201 -17 z m 150 411 b 385 669 150 565 226 669 b 613 421 536 669 613 560 l 613 378 l 150 378 z m 342 810 l 408 810 l 539 999 l 460 999 z '
    },
    ê: {
      ha: 768,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 667 196 532 -17 639 71 l 608 196 b 389 36 579 101 504 36 b 150 282 233 36 150 144 l 150 324 l 676 324 l 676 418 b 385 722 676 583 574 722 b 85 408 194 722 85 597 l 85 286 b 389 -17 85 106 201 -17 z m 150 411 b 385 669 150 565 226 669 b 613 421 536 669 613 560 l 613 378 l 150 378 z m 417 999 l 353 999 l 200 810 l 265 810 l 385 957 l 504 810 l 569 810 z '
    },
    ë: {
      ha: 768,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 667 196 532 -17 639 71 l 608 196 b 389 36 579 101 504 36 b 150 282 233 36 150 144 l 150 324 l 676 324 l 676 418 b 385 722 676 583 574 722 b 85 408 194 722 85 597 l 85 286 b 389 -17 85 106 201 -17 z m 150 411 b 385 669 150 565 226 669 b 613 421 536 669 613 560 l 613 378 l 150 378 z m 194 897 b 246 847 194 872 214 847 b 297 897 278 847 297 872 b 246 947 297 924 278 947 b 194 897 214 947 194 924 z m 475 897 b 526 847 475 872 494 847 b 578 897 558 847 578 872 b 526 947 578 924 558 947 b 475 897 494 947 475 924 z '
    },
    ì: { ha: 322, x_min: 0, x_max: 0, o: 'm 128 0 l 194 0 l 194 706 l 128 706 z m 72 999 l -7 999 l 124 810 l 190 810 z ' },
    í: { ha: 322, x_min: 0, x_max: 0, o: 'm 128 0 l 194 0 l 194 706 l 128 706 z m 133 810 l 200 810 l 331 999 l 251 999 z ' },
    î: {
      ha: 322,
      x_min: 0,
      x_max: 0,
      o: 'm 128 0 l 194 0 l 194 706 l 128 706 z m 193 999 l 129 999 l -24 810 l 42 810 l 161 957 l 281 810 l 346 810 z '
    },
    ï: {
      ha: 322,
      x_min: 0,
      x_max: 0,
      o:
        'm 128 0 l 194 0 l 194 706 l 128 706 z m -31 897 b 21 847 -31 872 -11 847 b 72 897 53 847 72 872 b 21 947 72 924 53 947 b -31 897 -11 947 -31 924 z m 250 897 b 301 847 250 872 269 847 b 353 897 333 847 353 872 b 301 947 353 924 333 947 b 250 897 269 947 250 924 z '
    },
    ð: {
      ha: 779,
      x_min: 0,
      x_max: 0,
      o:
        'm 207 789 l 426 854 b 618 550 521 768 583 671 b 375 693 586 625 501 693 b 85 375 197 693 85 571 l 85 285 b 388 -19 85 117 199 -19 b 694 299 578 -19 694 121 l 694 407 b 486 872 694 588 600 761 l 615 911 l 600 958 l 443 911 b 289 1014 394 953 342 988 l 204 1014 b 382 892 271 975 332 935 l 190 835 z m 388 35 b 151 282 246 35 151 131 l 151 376 b 390 639 151 542 239 639 b 628 376 515 639 628 528 l 628 292 b 388 35 628 146 542 35 z '
    },
    ñ: {
      ha: 808,
      x_min: 0,
      x_max: 0,
      o:
        'm 121 0 l 188 0 l 188 411 b 421 665 188 576 293 665 b 628 435 560 665 628 578 l 628 0 l 694 0 l 694 443 b 436 722 694 618 593 722 b 183 563 301 722 215 656 l 183 706 l 121 706 z m 219 821 b 299 925 233 878 246 925 b 518 826 367 925 450 826 b 635 967 594 826 619 900 l 588 976 b 518 874 576 928 567 874 b 297 972 464 874 382 972 b 172 831 218 972 185 910 z '
    },
    ò: {
      ha: 778,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 693 290 581 -17 693 118 l 693 415 b 389 722 693 588 581 722 b 85 415 197 722 85 588 l 85 290 b 389 -17 85 118 197 -17 z m 629 413 l 629 293 b 389 38 629 147 543 38 b 149 293 235 38 149 147 l 149 413 b 389 668 149 558 235 668 b 629 413 543 668 629 558 z m 306 999 l 226 999 l 357 810 l 424 810 z '
    },
    ó: {
      ha: 778,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 693 290 581 -17 693 118 l 693 415 b 389 722 693 588 581 722 b 85 415 197 722 85 588 l 85 290 b 389 -17 85 118 197 -17 z m 629 413 l 629 293 b 389 38 629 147 543 38 b 149 293 235 38 149 147 l 149 413 b 389 668 149 558 235 668 b 629 413 543 668 629 558 z m 354 810 l 421 810 l 551 999 l 472 999 z '
    },
    ô: {
      ha: 778,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 693 290 581 -17 693 118 l 693 415 b 389 722 693 588 581 722 b 85 415 197 722 85 588 l 85 290 b 389 -17 85 118 197 -17 z m 629 413 l 629 293 b 389 38 629 147 543 38 b 149 293 235 38 149 147 l 149 413 b 389 668 149 558 235 668 b 629 413 543 668 629 558 z m 421 999 l 357 999 l 204 810 l 269 810 l 389 957 l 508 810 l 574 810 z '
    },
    õ: {
      ha: 778,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 693 290 581 -17 693 118 l 693 415 b 389 722 693 588 581 722 b 85 415 197 722 85 588 l 85 290 b 389 -17 85 118 197 -17 z m 629 413 l 629 293 b 389 38 629 147 543 38 b 149 293 235 38 149 147 l 149 413 b 389 668 149 558 235 668 b 629 413 543 668 629 558 z m 207 821 b 286 925 221 878 233 925 b 506 826 354 925 438 826 b 622 967 582 826 607 900 l 575 976 b 506 874 564 928 554 874 b 285 972 451 874 369 972 b 160 831 206 972 172 910 z '
    },
    ö: {
      ha: 778,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 693 290 581 -17 693 118 l 693 415 b 389 722 693 588 581 722 b 85 415 197 722 85 588 l 85 290 b 389 -17 85 118 197 -17 z m 629 413 l 629 293 b 389 38 629 147 543 38 b 149 293 235 38 149 147 l 149 413 b 389 668 149 558 235 668 b 629 413 543 668 629 558 z m 197 897 b 249 847 197 872 217 847 b 300 897 281 847 300 872 b 249 947 300 924 281 947 b 197 897 217 947 197 924 z m 478 897 b 529 847 478 872 497 847 b 581 897 561 847 581 872 b 529 947 581 924 561 947 b 478 897 497 947 478 924 z '
    },
    '÷': {
      ha: 825,
      x_min: 0,
      x_max: 0,
      o:
        'm 118 472 l 707 472 l 707 528 l 118 528 z m 361 239 b 413 188 361 208 383 188 b 464 239 442 188 464 208 b 413 290 464 269 442 290 b 361 239 383 290 361 269 z m 361 761 b 413 710 361 731 383 710 b 464 761 442 710 464 731 b 413 813 464 792 442 813 b 361 761 383 813 361 792 z '
    },
    ø: {
      ha: 778,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 693 290 581 -17 693 118 l 693 415 b 604 642 693 506 661 586 l 693 776 l 639 776 l 569 671 b 389 722 521 703 460 722 b 85 415 197 722 85 588 l 85 290 b 172 64 85 200 115 119 l 85 -69 l 139 -69 l 207 35 b 389 -17 256 1 317 -17 z m 629 413 l 629 293 b 389 38 629 147 543 38 b 239 83 328 38 278 54 l 571 590 b 629 413 608 544 629 482 z m 149 293 l 149 413 b 389 668 149 558 235 668 b 538 622 449 668 499 651 l 206 115 b 149 293 168 161 149 222 z '
    },
    ù: {
      ha: 803,
      x_min: 0,
      x_max: 0,
      o:
        'm 682 706 l 615 706 l 615 294 b 385 40 615 129 513 40 b 181 271 246 40 181 128 l 181 706 l 114 706 l 114 263 b 369 -17 114 88 213 -17 b 619 143 504 -17 592 53 l 619 0 l 682 0 z m 331 999 l 251 999 l 382 810 l 449 810 z '
    },
    ú: {
      ha: 803,
      x_min: 0,
      x_max: 0,
      o:
        'm 682 706 l 615 706 l 615 294 b 385 40 615 129 513 40 b 181 271 246 40 181 128 l 181 706 l 114 706 l 114 263 b 369 -17 114 88 213 -17 b 619 143 504 -17 592 53 l 619 0 l 682 0 z m 354 810 l 421 810 l 551 999 l 472 999 z '
    },
    û: {
      ha: 803,
      x_min: 0,
      x_max: 0,
      o:
        'm 682 706 l 615 706 l 615 294 b 385 40 615 129 513 40 b 181 271 246 40 181 128 l 181 706 l 114 706 l 114 263 b 369 -17 114 88 213 -17 b 619 143 504 -17 592 53 l 619 0 l 682 0 z m 439 999 l 375 999 l 222 810 l 288 810 l 407 957 l 526 810 l 592 810 z '
    },
    ü: {
      ha: 803,
      x_min: 0,
      x_max: 0,
      o:
        'm 682 706 l 615 706 l 615 294 b 385 40 615 129 513 40 b 181 271 246 40 181 128 l 181 706 l 114 706 l 114 263 b 369 -17 114 88 213 -17 b 619 143 504 -17 592 53 l 619 0 l 682 0 z m 213 897 b 264 847 213 872 232 847 b 315 897 296 847 315 872 b 264 947 315 924 296 947 b 213 897 232 947 213 924 z m 493 897 b 544 847 493 872 513 847 b 596 897 576 847 596 872 b 544 947 596 924 576 947 b 493 897 513 947 493 924 z '
    },
    ý: {
      ha: 685,
      x_min: 0,
      x_max: 0,
      o:
        'm 228 -242 l 293 -242 l 381 3 l 638 706 l 569 706 l 344 81 l 115 706 l 47 706 l 311 0 z m 304 810 l 371 810 l 501 999 l 422 999 z '
    },
    þ: {
      ha: 815,
      x_min: 0,
      x_max: 0,
      o:
        'm 188 -242 l 188 131 b 440 -17 225 49 314 -17 b 731 290 621 -17 731 115 l 731 415 b 440 722 731 590 621 722 b 188 575 314 722 231 660 l 188 1014 l 121 1014 l 121 -242 z m 664 294 b 428 38 664 149 582 38 b 188 297 290 38 188 150 l 188 408 b 429 668 188 556 292 668 b 664 411 585 668 664 557 z '
    },
    ÿ: {
      ha: 685,
      x_min: 0,
      x_max: 0,
      o:
        'm 228 -242 l 293 -242 l 381 3 l 638 706 l 569 706 l 344 81 l 115 706 l 47 706 l 311 0 z m 150 897 b 201 847 150 872 169 847 b 253 897 233 847 253 872 b 201 947 253 924 233 947 b 150 897 169 947 150 924 z m 431 897 b 482 847 431 872 450 847 b 533 897 514 847 533 872 b 482 947 533 924 514 947 b 431 897 450 947 431 924 z '
    },
    Ā: {
      ha: 919,
      x_min: 0,
      x_max: 0,
      o:
        'm 494 972 l 425 972 l 56 0 l 126 0 l 224 267 l 694 267 l 793 0 l 864 0 z m 460 908 l 674 324 l 244 324 z m 250 1118 l 671 1118 l 671 1171 l 250 1171 z '
    },
    ā: {
      ha: 771,
      x_min: 0,
      x_max: 0,
      o:
        'm 344 -17 b 599 99 463 -17 561 39 l 599 0 l 663 0 l 663 465 b 394 722 663 611 554 722 b 125 538 263 722 158 654 l 188 538 b 394 668 221 618 290 668 b 596 463 519 668 596 579 l 596 322 b 356 428 557 374 465 428 b 72 210 190 428 72 347 b 344 -17 72 78 181 -17 z m 349 35 b 136 208 222 35 136 101 b 356 375 136 319 231 375 b 596 208 467 375 596 314 b 349 35 596 94 467 35 z m 199 871 l 603 871 l 603 924 l 199 924 z '
    },
    Ă: {
      ha: 919,
      x_min: 0,
      x_max: 0,
      o:
        'm 494 972 l 425 972 l 56 0 l 126 0 l 224 267 l 694 267 l 793 0 l 864 0 z m 460 908 l 674 324 l 244 324 z m 460 1060 b 672 1225 594 1060 667 1131 l 618 1225 b 460 1106 613 1156 558 1106 b 301 1225 361 1106 307 1156 l 247 1225 b 460 1060 253 1131 325 1060 z '
    },
    ă: {
      ha: 771,
      x_min: 0,
      x_max: 0,
      o:
        'm 344 -17 b 599 99 463 -17 561 39 l 599 0 l 663 0 l 663 465 b 394 722 663 611 554 722 b 125 538 263 722 158 654 l 188 538 b 394 668 221 618 290 668 b 596 463 519 668 596 579 l 596 322 b 356 428 557 374 465 428 b 72 210 190 428 72 347 b 344 -17 72 78 181 -17 z m 349 35 b 136 208 222 35 136 101 b 356 375 136 319 231 375 b 596 208 467 375 596 314 b 349 35 596 94 467 35 z m 403 810 b 608 999 538 810 608 893 l 556 999 b 403 854 556 914 506 854 b 250 999 300 854 250 914 l 197 999 b 403 810 197 893 268 810 z '
    },
    Ą: {
      ha: 919,
      x_min: 0,
      x_max: 0,
      o:
        'm 790 -258 b 857 -250 814 -258 842 -254 l 857 -206 b 810 -210 843 -208 826 -210 b 731 -149 758 -210 731 -190 b 864 0 731 -75 807 -31 l 494 972 l 425 972 l 56 0 l 126 0 l 224 267 l 694 267 l 793 0 b 672 -153 749 -18 672 -71 b 790 -258 672 -217 715 -258 z m 460 908 l 674 324 l 244 324 z '
    },
    ą: {
      ha: 771,
      x_min: 0,
      x_max: 0,
      o:
        'm 344 -17 b 599 99 463 -17 561 39 l 599 0 b 478 -153 539 -25 478 -75 b 596 -258 478 -217 521 -258 b 663 -250 619 -258 647 -254 l 663 -206 b 615 -210 649 -208 632 -210 b 536 -149 564 -210 536 -190 b 663 0 536 -78 594 -40 l 663 465 b 394 722 663 611 554 722 b 125 538 263 722 158 654 l 188 538 b 394 668 221 618 290 668 b 596 463 519 668 596 579 l 596 322 b 356 428 557 374 465 428 b 72 210 190 428 72 347 b 344 -17 72 78 181 -17 z m 349 35 b 136 208 222 35 136 101 b 356 375 136 319 231 375 b 596 208 467 375 596 314 b 349 35 596 94 467 35 z '
    },
    Ć: {
      ha: 971,
      x_min: 0,
      x_max: 0,
      o:
        'm 499 -19 b 874 310 718 -19 857 131 l 808 310 b 497 38 789 163 685 38 b 175 397 283 38 175 190 l 175 575 b 497 935 175 782 283 935 b 808 663 685 935 789 810 l 874 663 b 499 992 857 842 718 992 b 107 574 240 992 107 811 l 107 399 b 499 -19 107 161 240 -19 z m 454 1060 l 521 1060 l 638 1225 l 557 1225 z '
    },
    ć: {
      ha: 774,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 686 240 561 -17 668 96 l 625 240 b 389 38 606 128 532 38 b 151 292 238 38 151 147 l 151 414 b 389 668 151 558 238 668 b 625 465 532 668 606 578 l 686 465 b 389 722 668 610 561 722 b 85 415 203 722 85 592 l 85 290 b 389 -17 85 114 203 -17 z m 358 810 l 425 810 l 556 999 l 476 999 z '
    },
    Ĉ: {
      ha: 971,
      x_min: 0,
      x_max: 0,
      o:
        'm 499 -19 b 874 310 718 -19 857 131 l 808 310 b 497 38 789 163 685 38 b 175 397 283 38 175 190 l 175 575 b 497 935 175 782 283 935 b 808 663 685 935 789 810 l 874 663 b 499 992 857 842 718 992 b 107 574 240 992 107 811 l 107 399 b 499 -19 107 161 240 -19 z m 528 1225 l 464 1225 l 306 1060 l 374 1060 l 496 1188 l 618 1060 l 686 1060 z '
    },
    ĉ: {
      ha: 774,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 686 240 561 -17 668 96 l 625 240 b 389 38 606 128 532 38 b 151 292 238 38 151 147 l 151 414 b 389 668 151 558 238 668 b 625 465 532 668 606 578 l 686 465 b 389 722 668 610 561 722 b 85 415 203 722 85 592 l 85 290 b 389 -17 85 114 203 -17 z m 422 999 l 358 999 l 206 810 l 271 810 l 390 957 l 510 810 l 575 810 z '
    },
    Ċ: {
      ha: 971,
      x_min: 0,
      x_max: 0,
      o:
        'm 499 -19 b 874 310 718 -19 857 131 l 808 310 b 497 38 789 163 685 38 b 175 397 283 38 175 190 l 175 575 b 497 935 175 782 283 935 b 808 663 685 935 789 810 l 874 663 b 499 992 857 842 718 992 b 107 574 240 992 107 811 l 107 399 b 499 -19 107 161 240 -19 z m 439 1136 b 492 1085 439 1111 458 1085 b 544 1136 525 1085 544 1111 b 492 1188 544 1164 525 1188 b 439 1136 458 1188 439 1164 z '
    },
    ċ: {
      ha: 774,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 686 240 561 -17 668 96 l 625 240 b 389 38 606 128 532 38 b 151 292 238 38 151 147 l 151 414 b 389 668 151 558 238 668 b 625 465 532 668 606 578 l 686 465 b 389 722 668 610 561 722 b 85 415 203 722 85 592 l 85 290 b 389 -17 85 114 203 -17 z m 332 914 b 385 863 332 889 351 863 b 438 914 418 863 438 889 b 385 965 438 942 418 965 b 332 914 351 965 332 942 z '
    },
    Č: {
      ha: 971,
      x_min: 0,
      x_max: 0,
      o:
        'm 499 -19 b 874 310 718 -19 857 131 l 808 310 b 497 38 789 163 685 38 b 175 397 283 38 175 190 l 175 575 b 497 935 175 782 283 935 b 808 663 685 935 789 810 l 874 663 b 499 992 857 842 718 992 b 107 574 240 992 107 811 l 107 399 b 499 -19 107 161 240 -19 z m 690 1225 l 622 1225 l 500 1097 l 378 1225 l 310 1225 l 468 1060 l 532 1060 z '
    },
    č: {
      ha: 774,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 686 240 561 -17 668 96 l 625 240 b 389 38 606 128 532 38 b 151 292 238 38 151 147 l 151 414 b 389 668 151 558 238 668 b 625 465 532 668 606 578 l 686 465 b 389 722 668 610 561 722 b 85 415 203 722 85 592 l 85 290 b 389 -17 85 114 203 -17 z m 575 999 l 510 999 l 390 851 l 271 999 l 206 999 l 358 810 l 422 810 z '
    },
    Ď: {
      ha: 968,
      x_min: 0,
      x_max: 0,
      o:
        'm 864 374 l 864 599 b 481 972 864 808 728 972 l 135 972 l 135 0 l 481 0 b 864 374 728 0 864 164 z m 796 597 l 796 375 b 472 57 796 186 681 57 l 203 57 l 203 915 l 472 915 b 796 597 681 915 796 786 z m 644 1225 l 576 1225 l 454 1097 l 332 1225 l 264 1225 l 422 1060 l 486 1060 z '
    },
    ď: {
      ha: 992,
      x_min: 0,
      x_max: 0,
      o:
        'm 856 760 l 911 760 l 983 1014 l 911 1014 z m 628 1014 l 628 575 b 375 722 590 657 501 722 b 85 415 194 722 85 590 l 85 290 b 375 -17 85 115 194 -17 b 632 138 506 -17 596 51 l 632 0 l 694 0 l 694 1014 z m 151 411 b 388 668 151 557 233 668 b 628 408 525 668 628 556 l 628 297 b 386 38 628 150 524 38 b 151 294 231 38 151 149 z '
    },
    Đ: {
      ha: 1011,
      x_min: 0,
      x_max: 0,
      o:
        'm 58 460 l 176 460 l 176 0 l 522 0 b 906 374 769 0 906 164 l 906 599 b 522 972 906 808 769 972 l 176 972 l 176 513 l 58 513 z m 838 597 l 838 375 b 514 57 838 186 722 57 l 244 57 l 244 460 l 524 460 l 524 513 l 244 513 l 244 915 l 514 915 b 838 597 722 915 838 786 z '
    },
    đ: {
      ha: 844,
      x_min: 0,
      x_max: 0,
      o:
        'm 628 1014 l 628 882 l 433 882 l 433 831 l 628 831 l 628 575 b 375 722 590 657 501 722 b 85 415 194 722 85 590 l 85 290 b 375 -17 85 115 194 -17 b 632 138 506 -17 596 51 l 632 0 l 694 0 l 694 831 l 813 831 l 813 882 l 694 882 l 694 1014 z m 151 411 b 388 668 151 557 233 668 b 628 408 525 668 628 556 l 628 297 b 386 38 628 150 524 38 b 151 294 231 38 151 149 z '
    },
    Ē: {
      ha: 840,
      x_min: 0,
      x_max: 0,
      o:
        'm 135 0 l 760 0 l 760 57 l 203 57 l 203 464 l 718 464 l 718 522 l 203 522 l 203 915 l 758 915 l 758 972 l 135 972 z m 236 1118 l 657 1118 l 657 1171 l 236 1171 z '
    },
    ē: {
      ha: 768,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 667 196 532 -17 639 71 l 608 196 b 389 36 579 101 504 36 b 150 282 233 36 150 144 l 150 324 l 676 324 l 676 418 b 385 722 676 583 574 722 b 85 408 194 722 85 597 l 85 286 b 389 -17 85 106 201 -17 z m 150 411 b 385 669 150 565 226 669 b 613 421 536 669 613 560 l 613 378 l 150 378 z m 181 871 l 585 871 l 585 924 l 181 924 z '
    },
    Ĕ: {
      ha: 840,
      x_min: 0,
      x_max: 0,
      o:
        'm 135 0 l 760 0 l 760 57 l 203 57 l 203 464 l 718 464 l 718 522 l 203 522 l 203 915 l 758 915 l 758 972 l 135 972 z m 457 1060 b 669 1225 592 1060 664 1131 l 615 1225 b 457 1106 610 1156 556 1106 b 299 1225 358 1106 304 1156 l 244 1225 b 457 1060 250 1131 322 1060 z '
    },
    ĕ: {
      ha: 768,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 667 196 532 -17 639 71 l 608 196 b 389 36 579 101 504 36 b 150 282 233 36 150 144 l 150 324 l 676 324 l 676 418 b 385 722 676 583 574 722 b 85 408 194 722 85 597 l 85 286 b 389 -17 85 106 201 -17 z m 150 411 b 385 669 150 565 226 669 b 613 421 536 669 613 560 l 613 378 l 150 378 z m 388 810 b 593 999 522 810 593 893 l 540 999 b 388 854 540 914 490 854 b 235 999 285 854 235 914 l 182 999 b 388 810 182 893 253 810 z '
    },
    Ė: {
      ha: 840,
      x_min: 0,
      x_max: 0,
      o:
        'm 135 0 l 760 0 l 760 57 l 203 57 l 203 464 l 718 464 l 718 522 l 203 522 l 203 915 l 758 915 l 758 972 l 135 972 z m 397 1136 b 450 1085 397 1111 417 1085 b 503 1136 483 1085 503 1111 b 450 1188 503 1164 483 1188 b 397 1136 417 1188 397 1164 z '
    },
    ė: {
      ha: 768,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 667 196 532 -17 639 71 l 608 196 b 389 36 579 101 504 36 b 150 282 233 36 150 144 l 150 324 l 676 324 l 676 418 b 385 722 676 583 574 722 b 85 408 194 722 85 597 l 85 286 b 389 -17 85 106 201 -17 z m 150 411 b 385 669 150 565 226 669 b 613 421 536 669 613 560 l 613 378 l 150 378 z m 332 914 b 385 863 332 889 351 863 b 438 914 418 863 438 889 b 385 965 438 942 418 965 b 332 914 351 965 332 942 z '
    },
    Ę: {
      ha: 840,
      x_min: 0,
      x_max: 0,
      o:
        'm 135 0 l 696 0 b 575 -153 646 -18 575 -75 b 693 -258 575 -217 618 -258 b 760 -250 717 -258 744 -254 l 760 -206 b 713 -210 746 -208 729 -210 b 633 -149 661 -210 633 -190 b 760 0 633 -78 696 -37 l 760 57 l 203 57 l 203 464 l 718 464 l 718 522 l 203 522 l 203 915 l 758 915 l 758 972 l 135 972 z '
    },
    ę: {
      ha: 768,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 447 -11 408 -17 429 -15 b 357 -151 396 -46 357 -90 b 475 -258 357 -215 400 -258 b 542 -250 499 -258 526 -254 l 542 -206 b 494 -210 528 -208 511 -210 b 415 -149 443 -210 415 -190 b 564 38 415 -74 485 -21 b 667 196 615 75 651 129 l 608 196 b 389 36 579 101 504 36 b 150 282 233 36 150 144 l 150 324 l 676 324 l 676 418 b 385 722 676 583 574 722 b 85 408 194 722 85 597 l 85 286 b 389 -17 85 106 201 -17 z m 150 411 b 385 669 150 565 226 669 b 613 421 536 669 613 560 l 613 378 l 150 378 z '
    },
    Ě: {
      ha: 840,
      x_min: 0,
      x_max: 0,
      o:
        'm 135 0 l 760 0 l 760 57 l 203 57 l 203 464 l 718 464 l 718 522 l 203 522 l 203 915 l 758 915 l 758 972 l 135 972 z m 640 1225 l 572 1225 l 450 1097 l 328 1225 l 260 1225 l 418 1060 l 482 1060 z '
    },
    ě: {
      ha: 768,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 667 196 532 -17 639 71 l 608 196 b 389 36 579 101 504 36 b 150 282 233 36 150 144 l 150 324 l 676 324 l 676 418 b 385 722 676 583 574 722 b 85 408 194 722 85 597 l 85 286 b 389 -17 85 106 201 -17 z m 150 411 b 385 669 150 565 226 669 b 613 421 536 669 613 560 l 613 378 l 150 378 z m 569 999 l 504 999 l 385 851 l 265 999 l 200 999 l 353 810 l 417 810 z '
    },
    Ĝ: {
      ha: 983,
      x_min: 0,
      x_max: 0,
      o:
        'm 506 -19 b 883 358 742 -19 883 140 l 883 453 l 521 453 l 521 396 l 818 396 l 818 353 b 506 38 818 164 699 38 b 175 407 276 38 175 201 l 175 571 b 497 935 175 781 278 935 b 808 658 690 935 800 810 l 874 658 b 496 992 864 846 728 992 b 107 568 240 992 107 814 l 107 408 b 506 -19 107 174 238 -19 z m 526 1225 l 463 1225 l 304 1060 l 372 1060 l 494 1188 l 617 1060 l 685 1060 z '
    },
    ĝ: {
      ha: 813,
      x_min: 0,
      x_max: 0,
      o:
        'm 397 -258 b 692 -7 563 -258 692 -153 l 692 706 l 628 706 l 628 574 b 372 722 599 640 517 722 b 85 436 193 722 85 599 l 85 313 b 374 28 85 153 194 28 b 625 178 501 28 599 110 l 625 -6 b 397 -206 625 -128 536 -206 b 164 -92 297 -206 210 -168 l 97 -92 b 397 -258 144 -199 265 -258 z m 382 82 b 150 319 232 82 150 174 l 150 431 b 386 668 150 575 235 668 b 625 424 519 668 625 556 l 625 322 b 382 82 625 178 513 82 z m 443 999 l 379 999 l 226 810 l 292 810 l 411 957 l 531 810 l 596 810 z '
    },
    Ğ: {
      ha: 983,
      x_min: 0,
      x_max: 0,
      o:
        'm 506 -19 b 883 358 742 -19 883 140 l 883 453 l 521 453 l 521 396 l 818 396 l 818 353 b 506 38 818 164 699 38 b 175 407 276 38 175 201 l 175 571 b 497 935 175 781 278 935 b 808 658 690 935 800 810 l 874 658 b 496 992 864 846 728 992 b 107 568 240 992 107 814 l 107 408 b 506 -19 107 174 238 -19 z m 492 1060 b 704 1225 626 1060 699 1131 l 650 1225 b 492 1106 644 1156 590 1106 b 333 1225 393 1106 339 1156 l 279 1225 b 492 1060 285 1131 357 1060 z '
    },
    ğ: {
      ha: 813,
      x_min: 0,
      x_max: 0,
      o:
        'm 397 -258 b 692 -7 563 -258 692 -153 l 692 706 l 628 706 l 628 574 b 372 722 599 640 517 722 b 85 436 193 722 85 599 l 85 313 b 374 28 85 153 194 28 b 625 178 501 28 599 110 l 625 -6 b 397 -206 625 -128 536 -206 b 164 -92 297 -206 210 -168 l 97 -92 b 397 -258 144 -199 265 -258 z m 382 82 b 150 319 232 82 150 174 l 150 431 b 386 668 150 575 235 668 b 625 424 519 668 625 556 l 625 322 b 382 82 625 178 513 82 z m 410 810 b 615 999 544 810 615 893 l 563 999 b 410 854 563 914 513 854 b 257 999 307 854 257 914 l 204 999 b 410 810 204 893 275 810 z '
    },
    Ġ: {
      ha: 983,
      x_min: 0,
      x_max: 0,
      o:
        'm 506 -19 b 883 358 742 -19 883 140 l 883 453 l 521 453 l 521 396 l 818 396 l 818 353 b 506 38 818 164 699 38 b 175 407 276 38 175 201 l 175 571 b 497 935 175 781 278 935 b 808 658 690 935 800 810 l 874 658 b 496 992 864 846 728 992 b 107 568 240 992 107 814 l 107 408 b 506 -19 107 174 238 -19 z m 443 1136 b 496 1085 443 1111 463 1085 b 549 1136 529 1085 549 1111 b 496 1188 549 1164 529 1188 b 443 1136 463 1188 443 1164 z '
    },
    ġ: {
      ha: 813,
      x_min: 0,
      x_max: 0,
      o:
        'm 397 -258 b 692 -7 563 -258 692 -153 l 692 706 l 628 706 l 628 574 b 372 722 599 640 517 722 b 85 436 193 722 85 599 l 85 313 b 374 28 85 153 194 28 b 625 178 501 28 599 110 l 625 -6 b 397 -206 625 -128 536 -206 b 164 -92 297 -206 210 -168 l 97 -92 b 397 -258 144 -199 265 -258 z m 382 82 b 150 319 232 82 150 174 l 150 431 b 386 668 150 575 235 668 b 625 424 519 668 625 556 l 625 322 b 382 82 625 178 513 82 z m 349 914 b 401 863 349 889 368 863 b 454 914 435 863 454 889 b 401 965 454 942 435 965 b 349 914 368 965 349 942 z '
    },
    Ģ: {
      ha: 983,
      x_min: 0,
      x_max: 0,
      o:
        'm 506 -19 b 883 358 742 -19 883 140 l 883 453 l 521 453 l 521 396 l 818 396 l 818 353 b 506 38 818 164 699 38 b 175 407 276 38 175 201 l 175 571 b 497 935 175 781 278 935 b 808 658 690 935 800 810 l 874 658 b 496 992 864 846 728 992 b 107 568 240 992 107 814 l 107 408 b 506 -19 107 174 238 -19 z m 418 -347 l 474 -347 l 549 -115 l 476 -115 z '
    },
    ģ: {
      ha: 813,
      x_min: 0,
      x_max: 0,
      o:
        'm 397 -258 b 692 -7 563 -258 692 -153 l 692 706 l 628 706 l 628 574 b 372 722 599 640 517 722 b 85 436 193 722 85 599 l 85 313 b 374 28 85 153 194 28 b 625 178 501 28 599 110 l 625 -6 b 397 -206 625 -128 536 -206 b 164 -92 297 -206 210 -168 l 97 -92 b 397 -258 144 -199 265 -258 z m 382 82 b 150 319 232 82 150 174 l 150 431 b 386 668 150 575 235 668 b 625 424 519 668 625 556 l 625 322 b 382 82 625 178 513 82 z m 357 810 l 436 810 l 482 999 l 418 999 z '
    },
    Ĥ: {
      ha: 975,
      x_min: 0,
      x_max: 0,
      o:
        'm 135 0 l 203 0 l 203 461 l 772 461 l 772 0 l 840 0 l 840 972 l 772 972 l 772 521 l 203 521 l 203 972 l 135 972 z m 519 1225 l 456 1225 l 297 1060 l 365 1060 l 488 1188 l 610 1060 l 678 1060 z '
    },
    ĥ: {
      ha: 808,
      x_min: 0,
      x_max: 0,
      o:
        'm 121 0 l 188 0 l 188 411 b 421 665 188 576 293 665 b 628 435 560 665 628 578 l 628 0 l 694 0 l 694 443 b 436 722 694 618 593 722 b 188 569 307 722 226 663 l 188 1014 l 121 1014 z m 186 1267 l 122 1267 l -36 1101 l 32 1101 l 154 1229 l 276 1101 l 344 1101 z '
    },
    Ħ: {
      ha: 1058,
      x_min: 0,
      x_max: 0,
      o:
        'm 58 733 l 176 733 l 176 0 l 244 0 l 244 461 l 814 461 l 814 0 l 882 0 l 882 733 l 1000 733 l 1000 781 l 882 781 l 882 972 l 814 972 l 814 781 l 244 781 l 244 972 l 176 972 l 176 781 l 58 781 z m 244 521 l 244 733 l 814 733 l 814 521 z '
    },
    ħ: {
      ha: 838,
      x_min: 0,
      x_max: 0,
      o:
        'm 32 831 l 150 831 l 150 0 l 217 0 l 217 411 b 450 665 217 576 322 665 b 657 435 589 665 657 578 l 657 0 l 724 0 l 724 443 b 465 722 724 618 622 722 b 217 569 336 722 256 663 l 217 831 l 411 831 l 411 882 l 217 882 l 217 1014 l 150 1014 l 150 882 l 32 882 z '
    },
    Ĩ: {
      ha: 351,
      x_min: 0,
      x_max: 0,
      o:
        'm 142 0 l 210 0 l 210 972 l 142 972 z m -19 1065 b 60 1168 -8 1121 6 1168 b 300 1069 129 1168 231 1069 b 418 1208 376 1069 403 1143 l 372 1221 b 299 1118 354 1161 346 1118 b 60 1217 244 1118 144 1217 b -67 1074 -22 1217 -51 1158 z '
    },
    ĩ: {
      ha: 322,
      x_min: 0,
      x_max: 0,
      o:
        'm 128 0 l 194 0 l 194 706 l 128 706 z m -22 821 b 57 925 -8 878 4 925 b 276 826 125 925 208 826 b 393 967 353 826 378 900 l 346 976 b 276 874 335 928 325 874 b 56 972 222 874 140 972 b -69 831 -24 972 -57 910 z '
    },
    Ī: { ha: 351, x_min: 0, x_max: 0, o: 'm 142 0 l 210 0 l 210 972 l 142 972 z m -35 1118 l 386 1118 l 386 1171 l -35 1171 z ' },
    ī: { ha: 322, x_min: 0, x_max: 0, o: 'm 128 0 l 194 0 l 194 706 l 128 706 z m -40 871 l 364 871 l 364 924 l -40 924 z ' },
    Ĭ: {
      ha: 351,
      x_min: 0,
      x_max: 0,
      o:
        'm 142 0 l 210 0 l 210 972 l 142 972 z m 175 1060 b 388 1225 310 1060 382 1131 l 333 1225 b 175 1106 328 1156 274 1106 b 17 1225 76 1106 22 1156 l -37 1225 b 175 1060 -32 1131 40 1060 z '
    },
    ĭ: {
      ha: 322,
      x_min: 0,
      x_max: 0,
      o:
        'm 128 0 l 194 0 l 194 706 l 128 706 z m 161 810 b 367 999 296 810 367 893 l 314 999 b 161 854 314 914 264 854 b 8 999 58 854 8 914 l -44 999 b 161 810 -44 893 26 810 z '
    },
    Į: {
      ha: 351,
      x_min: 0,
      x_max: 0,
      o:
        'm 142 0 b 63 -149 103 -28 63 -82 b 171 -258 63 -215 106 -258 b 210 -256 188 -258 201 -257 l 210 -208 b 186 -210 200 -210 194 -210 b 121 -147 143 -210 121 -186 b 210 0 121 -79 161 -44 l 210 972 l 142 972 z '
    },
    į: {
      ha: 322,
      x_min: 0,
      x_max: 0,
      o:
        'm 156 -258 b 194 -256 172 -258 186 -257 l 194 -208 b 171 -210 185 -210 179 -210 b 106 -147 128 -210 106 -185 b 194 0 106 -79 147 -47 l 194 706 l 128 706 l 128 0 b 47 -149 89 -29 47 -82 b 156 -258 47 -215 90 -258 z m 108 914 b 161 863 108 889 128 863 b 214 914 194 863 214 889 b 161 965 214 942 194 965 b 108 914 128 965 108 942 z '
    },
    İ: {
      ha: 351,
      x_min: 0,
      x_max: 0,
      o:
        'm 142 0 l 210 0 l 210 972 l 142 972 z m 122 1136 b 175 1085 122 1111 142 1085 b 228 1136 208 1085 228 1111 b 175 1188 228 1164 208 1188 b 122 1136 142 1188 122 1164 z '
    },
    ı: { ha: 322, x_min: 0, x_max: 0, o: 'm 128 0 l 194 0 l 194 706 l 128 706 z ' },
    Ĳ: {
      ha: 1158,
      x_min: 0,
      x_max: 0,
      o:
        'm 142 0 l 210 0 l 210 972 l 142 972 z m 721 -19 b 1028 254 900 -19 1028 93 l 1028 972 l 960 972 l 960 254 b 721 38 960 124 867 38 b 482 250 571 38 482 125 l 482 257 l 415 257 l 415 250 b 721 -19 415 93 536 -19 z '
    },
    ĳ: {
      ha: 644,
      x_min: 0,
      x_max: 0,
      o:
        'm 128 0 l 194 0 l 194 706 l 128 706 z m 108 914 b 161 863 108 889 128 863 b 214 914 194 863 214 889 b 161 965 214 942 194 965 b 108 914 128 965 108 942 z m 303 -242 l 356 -242 b 517 -86 463 -242 517 -187 l 517 706 l 450 706 l 450 -85 b 340 -187 450 -153 421 -187 l 303 -187 z m 431 914 b 483 863 431 889 450 863 b 536 914 517 863 536 889 b 483 965 536 942 517 965 b 431 914 450 965 431 942 z '
    },
    Ĵ: {
      ha: 807,
      x_min: 0,
      x_max: 0,
      o:
        'm 369 -19 b 676 254 549 -19 676 93 l 676 972 l 608 972 l 608 254 b 369 38 608 124 515 38 b 131 250 219 38 131 125 l 131 257 l 64 257 l 64 250 b 369 -19 64 93 185 -19 z m 674 1225 l 610 1225 l 451 1060 l 519 1060 l 642 1188 l 764 1060 l 832 1060 z '
    },
    ĵ: {
      ha: 322,
      x_min: 0,
      x_max: 0,
      o:
        'm -19 -242 l 33 -242 b 194 -86 140 -242 194 -187 l 194 706 l 128 706 l 128 -85 b 18 -187 128 -153 99 -187 l -19 -187 z m 193 999 l 129 999 l -24 810 l 42 810 l 161 957 l 281 810 l 346 810 z '
    },
    Ķ: {
      ha: 821,
      x_min: 0,
      x_max: 0,
      o:
        'm 135 0 l 203 0 l 203 486 l 704 0 l 792 0 l 283 492 l 774 972 l 688 972 l 203 496 l 203 972 l 135 972 z m 344 -347 l 400 -347 l 475 -115 l 403 -115 z '
    },
    ķ: {
      ha: 688,
      x_min: 0,
      x_max: 0,
      o:
        'm 121 0 l 188 0 l 188 361 l 553 0 l 642 0 l 268 367 l 625 706 l 536 706 l 188 372 l 188 1014 l 121 1014 z m 272 -347 l 328 -347 l 403 -115 l 331 -115 z '
    },
    ĸ: {
      ha: 688,
      x_min: 0,
      x_max: 0,
      o: 'm 121 0 l 188 0 l 188 361 l 553 0 l 642 0 l 268 367 l 625 706 l 536 706 l 188 372 l 188 706 l 121 706 z '
    },
    Ĺ: {
      ha: 782,
      x_min: 0,
      x_max: 0,
      o: 'm 135 0 l 724 0 l 724 57 l 203 57 l 203 972 l 135 972 z m 144 1060 l 211 1060 l 328 1225 l 247 1225 z '
    },
    ĺ: { ha: 322, x_min: 0, x_max: 0, o: 'm 128 0 l 194 0 l 194 1014 l 128 1014 z m 133 1101 l 200 1101 l 317 1267 l 236 1267 z ' },
    Ļ: {
      ha: 782,
      x_min: 0,
      x_max: 0,
      o: 'm 135 0 l 724 0 l 724 57 l 203 57 l 203 972 l 135 972 z m 347 -347 l 403 -347 l 478 -115 l 406 -115 z '
    },
    ļ: { ha: 322, x_min: 0, x_max: 0, o: 'm 128 0 l 194 0 l 194 1014 l 128 1014 z m 64 -347 l 119 -347 l 194 -115 l 122 -115 z ' },
    Ľ: {
      ha: 782,
      x_min: 0,
      x_max: 0,
      o: 'm 457 718 l 513 718 l 585 972 l 513 972 z m 135 0 l 724 0 l 724 57 l 203 57 l 203 972 l 135 972 z '
    },
    ľ: { ha: 493, x_min: 0, x_max: 0, o: 'm 357 760 l 413 760 l 485 1014 l 413 1014 z m 128 0 l 194 0 l 194 1014 l 128 1014 z ' },
    Ŀ: {
      ha: 783,
      x_min: 0,
      x_max: 0,
      o:
        'm 135 0 l 724 0 l 724 57 l 203 57 l 203 972 l 135 972 z m 426 482 b 481 428 426 450 450 428 b 535 482 511 428 535 450 b 481 536 535 514 511 536 b 426 482 450 536 426 514 z '
    },
    ŀ: {
      ha: 490,
      x_min: 0,
      x_max: 0,
      o:
        'm 128 0 l 194 0 l 194 1014 l 128 1014 z m 333 424 b 388 369 333 392 357 369 b 442 424 418 369 442 392 b 388 478 442 456 418 478 b 333 424 357 478 333 456 z '
    },
    Ł: {
      ha: 810,
      x_min: 0,
      x_max: 0,
      o:
        'm 35 386 l 163 464 l 163 0 l 751 0 l 751 57 l 231 57 l 231 506 l 485 660 l 485 719 l 231 565 l 231 972 l 163 972 l 163 524 l 35 446 z '
    },
    ł: {
      ha: 339,
      x_min: 0,
      x_max: 0,
      o: 'm 47 425 l 133 501 l 133 0 l 200 0 l 200 560 l 307 656 l 307 719 l 200 624 l 200 1014 l 133 1014 l 133 565 l 47 489 z '
    },
    Ń: {
      ha: 981,
      x_min: 0,
      x_max: 0,
      o:
        'm 135 0 l 200 0 l 200 861 l 782 0 l 846 0 l 846 972 l 781 972 l 781 110 l 199 972 l 135 972 z m 453 1060 l 519 1060 l 636 1225 l 556 1225 z '
    },
    ń: {
      ha: 808,
      x_min: 0,
      x_max: 0,
      o:
        'm 121 0 l 188 0 l 188 411 b 421 665 188 576 293 665 b 628 435 560 665 628 578 l 628 0 l 694 0 l 694 443 b 436 722 694 618 593 722 b 183 563 301 722 215 656 l 183 706 l 121 706 z m 356 810 l 422 810 l 553 999 l 474 999 z '
    },
    Ņ: {
      ha: 981,
      x_min: 0,
      x_max: 0,
      o:
        'm 135 0 l 200 0 l 200 861 l 782 0 l 846 0 l 846 972 l 781 972 l 781 110 l 199 972 l 135 972 z m 404 -347 l 460 -347 l 535 -115 l 463 -115 z '
    },
    ņ: {
      ha: 808,
      x_min: 0,
      x_max: 0,
      o:
        'm 121 0 l 188 0 l 188 411 b 421 665 188 576 293 665 b 628 435 560 665 628 578 l 628 0 l 694 0 l 694 443 b 436 722 694 618 593 722 b 183 563 301 722 215 656 l 183 706 l 121 706 z m 328 -347 l 383 -347 l 458 -115 l 386 -115 z '
    },
    Ň: {
      ha: 981,
      x_min: 0,
      x_max: 0,
      o:
        'm 135 0 l 200 0 l 200 861 l 782 0 l 846 0 l 846 972 l 781 972 l 781 110 l 199 972 l 135 972 z m 683 1225 l 615 1225 l 493 1097 l 371 1225 l 303 1225 l 461 1060 l 525 1060 z '
    },
    ň: {
      ha: 808,
      x_min: 0,
      x_max: 0,
      o:
        'm 121 0 l 188 0 l 188 411 b 421 665 188 576 293 665 b 628 435 560 665 628 578 l 628 0 l 694 0 l 694 443 b 436 722 694 618 593 722 b 183 563 301 722 215 656 l 183 706 l 121 706 z m 593 999 l 528 999 l 408 851 l 289 999 l 224 999 l 376 810 l 440 810 z '
    },
    ŉ: {
      ha: 954,
      x_min: 0,
      x_max: 0,
      o:
        'm 35 760 l 90 760 l 163 1014 l 90 1014 z m 267 0 l 333 0 l 333 411 b 567 665 333 576 439 665 b 774 435 706 665 774 578 l 774 0 l 840 0 l 840 443 b 582 722 840 618 739 722 b 329 563 447 722 361 656 l 329 706 l 267 706 z '
    },
    Ŋ: {
      ha: 981,
      x_min: 0,
      x_max: 0,
      o:
        'm 135 0 l 200 0 l 200 861 l 781 1 l 781 -7 b 593 -186 781 -124 717 -186 l 563 -186 l 563 -242 l 606 -242 b 846 -8 760 -242 846 -149 l 846 972 l 781 972 l 781 110 l 199 972 l 135 972 z '
    },
    ŋ: {
      ha: 808,
      x_min: 0,
      x_max: 0,
      o:
        'm 121 0 l 188 0 l 188 411 b 421 665 188 576 293 665 b 628 435 560 665 628 578 l 628 -21 b 464 -186 628 -124 576 -186 l 442 -186 l 442 -242 l 463 -242 b 694 -22 606 -242 694 -160 l 694 443 b 436 722 694 618 593 722 b 183 563 301 722 215 656 l 183 706 l 121 706 z '
    },
    Ō: {
      ha: 1006,
      x_min: 0,
      x_max: 0,
      o:
        'm 899 569 b 503 992 899 799 771 992 b 107 569 235 992 107 799 l 107 403 b 503 -19 107 174 235 -19 b 899 403 771 -19 899 174 z m 832 400 b 503 36 832 206 731 36 b 174 400 275 36 174 206 l 174 572 b 503 936 174 767 275 936 b 832 572 731 936 832 767 z m 293 1118 l 714 1118 l 714 1171 l 293 1171 z '
    },
    ō: {
      ha: 778,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 693 290 581 -17 693 118 l 693 415 b 389 722 693 588 581 722 b 85 415 197 722 85 588 l 85 290 b 389 -17 85 118 197 -17 z m 629 413 l 629 293 b 389 38 629 147 543 38 b 149 293 235 38 149 147 l 149 413 b 389 668 149 558 235 668 b 629 413 543 668 629 558 z m 188 871 l 592 871 l 592 924 l 188 924 z '
    },
    Ŏ: {
      ha: 1006,
      x_min: 0,
      x_max: 0,
      o:
        'm 899 569 b 503 992 899 799 771 992 b 107 569 235 992 107 799 l 107 403 b 503 -19 107 174 235 -19 b 899 403 771 -19 899 174 z m 832 400 b 503 36 832 206 731 36 b 174 400 275 36 174 206 l 174 572 b 503 936 174 767 275 936 b 832 572 731 936 832 767 z m 503 1060 b 715 1225 638 1060 710 1131 l 661 1225 b 503 1106 656 1156 601 1106 b 344 1225 404 1106 350 1156 l 290 1225 b 503 1060 296 1131 368 1060 z '
    },
    ŏ: {
      ha: 778,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 693 290 581 -17 693 118 l 693 415 b 389 722 693 588 581 722 b 85 415 197 722 85 588 l 85 290 b 389 -17 85 118 197 -17 z m 629 413 l 629 293 b 389 38 629 147 543 38 b 149 293 235 38 149 147 l 149 413 b 389 668 149 558 235 668 b 629 413 543 668 629 558 z m 389 810 b 594 999 524 810 594 893 l 542 999 b 389 854 542 914 492 854 b 236 999 286 854 236 914 l 183 999 b 389 810 183 893 254 810 z '
    },
    Ő: {
      ha: 1006,
      x_min: 0,
      x_max: 0,
      o:
        'm 899 569 b 503 992 899 799 771 992 b 107 569 235 992 107 799 l 107 403 b 503 -19 107 174 235 -19 b 899 403 771 -19 899 174 z m 832 400 b 503 36 832 206 731 36 b 174 400 275 36 174 206 l 174 572 b 503 936 174 767 275 936 b 832 572 731 936 832 767 z m 331 1060 l 392 1060 l 483 1225 l 413 1225 z m 628 1060 l 688 1060 l 781 1225 l 708 1225 z '
    },
    ő: {
      ha: 778,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 693 290 581 -17 693 118 l 693 415 b 389 722 693 588 581 722 b 85 415 197 722 85 588 l 85 290 b 389 -17 85 118 197 -17 z m 629 413 l 629 293 b 389 38 629 147 543 38 b 149 293 235 38 149 147 l 149 413 b 389 668 149 558 235 668 b 629 413 543 668 629 558 z m 236 810 l 296 810 l 401 999 l 331 999 z m 492 810 l 551 810 l 657 999 l 586 999 z '
    },
    Œ: {
      ha: 1490,
      x_min: 0,
      x_max: 0,
      o:
        'm 532 0 l 1410 0 l 1410 57 l 853 57 l 853 464 l 1368 464 l 1368 522 l 853 522 l 853 915 l 1408 915 l 1408 972 l 532 972 b 107 553 243 972 107 786 l 107 419 b 532 0 107 186 243 0 z m 175 417 l 175 556 b 532 915 175 760 293 915 l 785 915 l 785 57 l 532 57 b 175 417 293 57 175 213 z '
    },
    œ: {
      ha: 1313,
      x_min: 0,
      x_max: 0,
      o:
        'm 389 -17 b 660 143 519 -17 619 56 b 933 -17 701 49 801 -17 b 1211 196 1076 -17 1183 71 l 1153 196 b 933 36 1124 101 1049 36 b 694 282 778 36 694 144 l 694 324 l 1221 324 l 1221 418 b 929 722 1221 583 1118 722 b 660 560 797 722 701 664 b 389 722 613 660 519 722 b 85 415 197 722 85 588 l 85 290 b 389 -17 85 118 197 -17 z m 629 413 l 629 293 b 389 38 629 147 543 38 b 149 293 235 38 149 147 l 149 413 b 389 668 149 558 235 668 b 629 413 543 668 629 558 z m 694 411 b 929 669 694 565 771 669 b 1157 421 1081 669 1157 560 l 1157 378 l 694 378 z '
    },
    Ŕ: {
      ha: 925,
      x_min: 0,
      x_max: 0,
      o:
        'm 757 0 l 832 0 l 614 388 b 835 674 753 424 835 538 b 521 972 835 833 721 972 l 135 972 l 135 0 l 203 0 l 203 376 l 518 376 l 549 376 z m 203 432 l 203 917 l 510 917 b 767 674 681 917 767 806 b 508 432 767 542 682 432 z m 399 1060 l 465 1060 l 582 1225 l 501 1225 z '
    },
    ŕ: {
      ha: 475,
      x_min: 0,
      x_max: 0,
      o:
        'm 121 0 l 188 0 l 188 354 b 435 649 188 547 290 649 l 442 649 l 442 710 l 435 710 b 183 531 299 710 206 635 l 183 706 l 121 706 z m 221 810 l 288 810 l 418 999 l 339 999 z '
    },
    Ŗ: {
      ha: 925,
      x_min: 0,
      x_max: 0,
      o:
        'm 757 0 l 832 0 l 614 388 b 835 674 753 424 835 538 b 521 972 835 833 721 972 l 135 972 l 135 0 l 203 0 l 203 376 l 518 376 l 549 376 z m 203 432 l 203 917 l 510 917 b 767 674 681 917 767 806 b 508 432 767 542 682 432 z m 381 -347 l 436 -347 l 511 -115 l 439 -115 z '
    },
    ŗ: {
      ha: 475,
      x_min: 0,
      x_max: 0,
      o:
        'm 121 0 l 188 0 l 188 354 b 435 649 188 547 290 649 l 442 649 l 442 710 l 435 710 b 183 531 299 710 206 635 l 183 706 l 121 706 z m 57 -347 l 113 -347 l 188 -115 l 115 -115 z '
    },
    Ř: {
      ha: 925,
      x_min: 0,
      x_max: 0,
      o:
        'm 757 0 l 832 0 l 614 388 b 835 674 753 424 835 538 b 521 972 835 833 721 972 l 135 972 l 135 0 l 203 0 l 203 376 l 518 376 l 549 376 z m 203 432 l 203 917 l 510 917 b 767 674 681 917 767 806 b 508 432 767 542 682 432 z m 628 1225 l 560 1225 l 438 1097 l 315 1225 l 247 1225 l 406 1060 l 469 1060 z '
    },
    ř: {
      ha: 475,
      x_min: 0,
      x_max: 0,
      o:
        'm 121 0 l 188 0 l 188 354 b 435 649 188 547 290 649 l 442 649 l 442 710 l 435 710 b 183 531 299 710 206 635 l 183 706 l 121 706 z m 465 999 l 400 999 l 281 851 l 161 999 l 96 999 l 249 810 l 313 810 z '
    },
    Ś: {
      ha: 906,
      x_min: 0,
      x_max: 0,
      o:
        'm 458 -19 b 813 258 654 -19 813 82 b 614 489 813 379 735 457 l 324 565 b 186 736 231 590 186 642 b 443 936 186 861 286 936 b 711 717 607 936 711 846 l 711 696 l 774 696 l 774 718 b 443 992 774 879 638 992 b 121 732 250 992 121 893 b 304 508 121 615 188 539 l 592 433 b 747 254 693 407 747 344 b 458 36 747 115 625 36 b 169 268 289 36 169 126 l 169 289 l 104 289 l 104 267 b 458 -19 104 94 256 -19 z m 413 1060 l 479 1060 l 596 1225 l 515 1225 z '
    },
    ś: {
      ha: 729,
      x_min: 0,
      x_max: 0,
      o:
        'm 372 -17 b 653 189 524 -17 653 64 b 496 363 653 279 601 336 l 267 419 b 171 528 204 435 171 468 b 360 668 171 617 243 668 b 551 504 481 668 551 601 l 551 500 l 617 500 l 617 504 b 360 722 617 633 511 722 b 106 528 208 722 106 647 b 254 360 106 439 160 383 l 486 303 b 588 188 556 286 588 246 b 374 38 588 94 493 38 b 151 203 251 38 151 99 l 151 206 l 86 206 l 86 201 b 372 -17 86 68 210 -17 z m 318 810 l 385 810 l 515 999 l 436 999 z '
    },
    Ŝ: {
      ha: 906,
      x_min: 0,
      x_max: 0,
      o:
        'm 458 -19 b 813 258 654 -19 813 82 b 614 489 813 379 735 457 l 324 565 b 186 736 231 590 186 642 b 443 936 186 861 286 936 b 711 717 607 936 711 846 l 711 696 l 774 696 l 774 718 b 443 992 774 879 638 992 b 121 732 250 992 121 893 b 304 508 121 615 188 539 l 592 433 b 747 254 693 407 747 344 b 458 36 747 115 625 36 b 169 268 289 36 169 126 l 169 289 l 104 289 l 104 267 b 458 -19 104 94 256 -19 z m 483 1225 l 419 1225 l 261 1060 l 329 1060 l 451 1188 l 574 1060 l 642 1060 z '
    },
    ŝ: {
      ha: 729,
      x_min: 0,
      x_max: 0,
      o:
        'm 372 -17 b 653 189 524 -17 653 64 b 496 363 653 279 601 336 l 267 419 b 171 528 204 435 171 468 b 360 668 171 617 243 668 b 551 504 481 668 551 601 l 551 500 l 617 500 l 617 504 b 360 722 617 633 511 722 b 106 528 208 722 106 647 b 254 360 106 439 160 383 l 486 303 b 588 188 556 286 588 246 b 374 38 588 94 493 38 b 151 203 251 38 151 99 l 151 206 l 86 206 l 86 201 b 372 -17 86 68 210 -17 z m 396 999 l 332 999 l 179 810 l 244 810 l 364 957 l 483 810 l 549 810 z '
    },
    Ş: {
      ha: 906,
      x_min: 0,
      x_max: 0,
      o:
        'm 468 -258 b 596 -162 543 -258 596 -225 b 489 -74 596 -107 549 -76 l 463 -72 l 471 -19 b 813 258 661 -15 813 85 b 614 489 813 379 735 457 l 324 565 b 186 736 231 590 186 642 b 443 936 186 861 286 936 b 711 717 607 936 711 846 l 711 696 l 774 696 l 774 718 b 443 992 774 879 638 992 b 121 732 250 992 121 893 b 304 508 121 615 188 539 l 592 433 b 747 254 693 407 747 344 b 458 36 747 115 625 36 b 169 268 289 36 169 126 l 169 289 l 104 289 l 104 267 b 422 -18 104 104 242 -6 l 406 -111 l 467 -115 b 543 -165 511 -118 543 -133 b 460 -214 543 -201 513 -214 b 376 -206 432 -214 403 -211 l 376 -250 b 468 -258 406 -256 440 -258 z '
    },
    ş: {
      ha: 729,
      x_min: 0,
      x_max: 0,
      o:
        'm 388 -258 b 515 -162 463 -258 515 -225 b 408 -74 515 -107 468 -76 l 382 -72 l 390 -15 b 653 189 533 -10 653 68 b 496 363 653 279 601 336 l 267 419 b 171 528 204 435 171 468 b 360 668 171 617 243 668 b 551 504 481 668 551 601 l 551 500 l 617 500 l 617 504 b 360 722 617 633 511 722 b 106 528 208 722 106 647 b 254 360 106 439 160 383 l 486 303 b 588 188 556 286 588 246 b 374 38 588 94 493 38 b 151 203 251 38 151 99 l 151 206 l 86 206 l 86 201 b 343 -15 86 76 194 -6 l 325 -111 l 386 -115 b 463 -165 431 -118 463 -133 b 379 -214 463 -201 432 -214 b 296 -206 351 -214 322 -211 l 296 -250 b 388 -258 325 -256 360 -258 z '
    },
    Š: {
      ha: 906,
      x_min: 0,
      x_max: 0,
      o:
        'm 458 -19 b 813 258 654 -19 813 82 b 614 489 813 379 735 457 l 324 565 b 186 736 231 590 186 642 b 443 936 186 861 286 936 b 711 717 607 936 711 846 l 711 696 l 774 696 l 774 718 b 443 992 774 879 638 992 b 121 732 250 992 121 893 b 304 508 121 615 188 539 l 592 433 b 747 254 693 407 747 344 b 458 36 747 115 625 36 b 169 268 289 36 169 126 l 169 289 l 104 289 l 104 267 b 458 -19 104 94 256 -19 z m 642 1225 l 574 1225 l 451 1097 l 329 1225 l 261 1225 l 419 1060 l 483 1060 z '
    },
    š: {
      ha: 729,
      x_min: 0,
      x_max: 0,
      o:
        'm 372 -17 b 653 189 524 -17 653 64 b 496 363 653 279 601 336 l 267 419 b 171 528 204 435 171 468 b 360 668 171 617 243 668 b 551 504 481 668 551 601 l 551 500 l 617 500 l 617 504 b 360 722 617 633 511 722 b 106 528 208 722 106 647 b 254 360 106 439 160 383 l 486 303 b 588 188 556 286 588 246 b 374 38 588 94 493 38 b 151 203 251 38 151 99 l 151 206 l 86 206 l 86 201 b 372 -17 86 68 210 -17 z m 540 999 l 475 999 l 356 851 l 236 999 l 171 999 l 324 810 l 388 810 z '
    },
    Ţ: {
      ha: 765,
      x_min: 0,
      x_max: 0,
      o: 'm 349 0 l 417 0 l 417 915 l 725 915 l 725 972 l 40 972 l 40 915 l 349 915 z m 286 -347 l 342 -347 l 417 -115 l 344 -115 z '
    },
    ţ: {
      ha: 508,
      x_min: 0,
      x_max: 0,
      o:
        'm 442 0 l 442 54 l 379 54 b 250 183 283 54 250 93 l 250 651 l 444 651 l 444 706 l 250 706 l 250 910 l 183 910 l 183 706 l 54 706 l 54 651 l 183 651 l 183 183 b 369 0 183 67 240 0 z m 226 -347 l 282 -347 l 357 -115 l 285 -115 z '
    },
    Ť: {
      ha: 765,
      x_min: 0,
      x_max: 0,
      o:
        'm 349 0 l 417 0 l 417 915 l 725 915 l 725 972 l 40 972 l 40 915 l 349 915 z m 572 1225 l 504 1225 l 382 1097 l 260 1225 l 192 1225 l 350 1060 l 414 1060 z '
    },
    ť: {
      ha: 515,
      x_min: 0,
      x_max: 0,
      o:
        'm 369 828 l 424 828 l 475 1014 l 408 1014 z m 442 0 l 442 54 l 379 54 b 250 183 283 54 250 93 l 250 651 l 444 651 l 444 706 l 250 706 l 250 910 l 183 910 l 183 706 l 54 706 l 54 651 l 183 651 l 183 183 b 369 0 183 67 240 0 z '
    },
    Ŧ: {
      ha: 765,
      x_min: 0,
      x_max: 0,
      o:
        'm 129 443 l 349 443 l 349 0 l 417 0 l 417 443 l 636 443 l 636 497 l 417 497 l 417 915 l 725 915 l 725 972 l 40 972 l 40 915 l 349 915 l 349 497 l 129 497 z '
    },
    ŧ: {
      ha: 508,
      x_min: 0,
      x_max: 0,
      o:
        'm 54 343 l 183 343 l 183 183 b 369 0 183 67 240 0 l 442 0 l 442 54 l 379 54 b 250 183 283 54 250 93 l 250 343 l 418 343 l 418 396 l 250 396 l 250 651 l 444 651 l 444 706 l 250 706 l 250 910 l 183 910 l 183 706 l 54 706 l 54 651 l 183 651 l 183 396 l 54 396 z '
    },
    Ũ: {
      ha: 981,
      x_min: 0,
      x_max: 0,
      o:
        'm 490 -19 b 851 317 711 -19 851 122 l 851 972 l 783 972 l 783 310 b 490 38 783 149 671 38 b 197 310 310 38 197 149 l 197 972 l 129 972 l 129 317 b 490 -19 129 122 269 -19 z m 299 1065 b 378 1168 310 1121 324 1168 b 618 1069 447 1168 549 1069 b 736 1208 694 1069 721 1143 l 690 1221 b 617 1118 672 1161 664 1118 b 378 1217 563 1118 463 1217 b 251 1074 296 1217 267 1158 z '
    },
    ũ: {
      ha: 803,
      x_min: 0,
      x_max: 0,
      o:
        'm 682 706 l 615 706 l 615 294 b 385 40 615 129 513 40 b 181 271 246 40 181 128 l 181 706 l 114 706 l 114 263 b 369 -17 114 88 213 -17 b 619 143 504 -17 592 53 l 619 0 l 682 0 z m 219 821 b 299 925 233 878 246 925 b 518 826 367 925 450 826 b 635 967 594 826 619 900 l 588 976 b 518 874 576 928 567 874 b 297 972 464 874 382 972 b 172 831 218 972 185 910 z '
    },
    Ū: {
      ha: 981,
      x_min: 0,
      x_max: 0,
      o:
        'm 490 -19 b 851 317 711 -19 851 122 l 851 972 l 783 972 l 783 310 b 490 38 783 149 671 38 b 197 310 310 38 197 149 l 197 972 l 129 972 l 129 317 b 490 -19 129 122 269 -19 z m 281 1118 l 701 1118 l 701 1171 l 281 1171 z '
    },
    ū: {
      ha: 803,
      x_min: 0,
      x_max: 0,
      o:
        'm 682 706 l 615 706 l 615 294 b 385 40 615 129 513 40 b 181 271 246 40 181 128 l 181 706 l 114 706 l 114 263 b 369 -17 114 88 213 -17 b 619 143 504 -17 592 53 l 619 0 l 682 0 z m 207 871 l 611 871 l 611 924 l 207 924 z '
    },
    Ŭ: {
      ha: 981,
      x_min: 0,
      x_max: 0,
      o:
        'm 490 -19 b 851 317 711 -19 851 122 l 851 972 l 783 972 l 783 310 b 490 38 783 149 671 38 b 197 310 310 38 197 149 l 197 972 l 129 972 l 129 317 b 490 -19 129 122 269 -19 z m 490 1060 b 703 1225 625 1060 697 1131 l 649 1225 b 490 1106 643 1156 589 1106 b 332 1225 392 1106 338 1156 l 278 1225 b 490 1060 283 1131 356 1060 z '
    },
    ŭ: {
      ha: 803,
      x_min: 0,
      x_max: 0,
      o:
        'm 682 706 l 615 706 l 615 294 b 385 40 615 129 513 40 b 181 271 246 40 181 128 l 181 706 l 114 706 l 114 263 b 369 -17 114 88 213 -17 b 619 143 504 -17 592 53 l 619 0 l 682 0 z m 408 810 b 614 999 543 810 614 893 l 561 999 b 408 854 561 914 511 854 b 256 999 306 854 256 914 l 203 999 b 408 810 203 893 274 810 z '
    },
    Ů: {
      ha: 981,
      x_min: 0,
      x_max: 0,
      o:
        'm 490 -19 b 851 317 711 -19 851 122 l 851 972 l 783 972 l 783 310 b 490 38 783 149 671 38 b 197 310 310 38 197 149 l 197 972 l 129 972 l 129 317 b 490 -19 129 122 269 -19 z m 490 1097 b 414 1171 442 1097 414 1129 b 490 1244 414 1213 442 1244 b 567 1171 539 1244 567 1213 b 490 1097 567 1129 539 1097 z m 490 1060 b 610 1171 564 1060 610 1110 b 490 1282 610 1232 564 1282 b 371 1171 417 1282 371 1232 b 490 1060 371 1110 417 1060 z '
    },
    ů: {
      ha: 803,
      x_min: 0,
      x_max: 0,
      o:
        'm 682 706 l 615 706 l 615 294 b 385 40 615 129 513 40 b 181 271 246 40 181 128 l 181 706 l 114 706 l 114 263 b 369 -17 114 88 213 -17 b 619 143 504 -17 592 53 l 619 0 l 682 0 z m 404 847 b 328 921 356 847 328 879 b 404 994 328 963 356 994 b 481 921 453 994 481 963 b 404 847 481 879 453 847 z m 404 810 b 524 921 478 810 524 860 b 404 1032 524 982 478 1032 b 285 921 331 1032 285 982 b 404 810 285 860 331 810 z '
    },
    Ű: {
      ha: 981,
      x_min: 0,
      x_max: 0,
      o:
        'm 490 -19 b 851 317 711 -19 851 122 l 851 972 l 783 972 l 783 310 b 490 38 783 149 671 38 b 197 310 310 38 197 149 l 197 972 l 129 972 l 129 317 b 490 -19 129 122 269 -19 z m 304 1060 l 365 1060 l 457 1225 l 386 1225 z m 601 1060 l 661 1060 l 754 1225 l 682 1225 z '
    },
    ű: {
      ha: 803,
      x_min: 0,
      x_max: 0,
      o:
        'm 682 706 l 615 706 l 615 294 b 385 40 615 129 513 40 b 181 271 246 40 181 128 l 181 706 l 114 706 l 114 263 b 369 -17 114 88 213 -17 b 619 143 504 -17 592 53 l 619 0 l 682 0 z m 232 810 l 292 810 l 397 999 l 326 999 z m 488 810 l 547 810 l 653 999 l 582 999 z '
    },
    Ų: {
      ha: 981,
      x_min: 0,
      x_max: 0,
      o:
        'm 490 -19 b 533 -18 504 -19 519 -19 b 458 -150 499 -42 458 -83 b 576 -258 458 -214 504 -258 b 643 -250 600 -258 628 -254 l 643 -206 b 596 -210 629 -208 613 -210 b 517 -149 543 -210 517 -189 b 683 25 517 -69 583 -32 b 851 317 794 89 851 182 l 851 972 l 783 972 l 783 310 b 490 38 783 149 671 38 b 197 310 310 38 197 149 l 197 972 l 129 972 l 129 317 b 490 -19 129 122 269 -19 z '
    },
    ų: {
      ha: 803,
      x_min: 0,
      x_max: 0,
      o:
        'm 682 706 l 615 706 l 615 294 b 385 40 615 129 513 40 b 181 271 246 40 181 128 l 181 706 l 114 706 l 114 263 b 369 -17 114 88 213 -17 b 619 143 504 -17 592 53 l 619 0 b 497 -144 563 -22 499 -68 b 615 -258 496 -219 546 -257 b 682 -250 639 -258 667 -254 l 682 -206 b 635 -210 668 -208 651 -210 b 556 -143 583 -210 556 -189 b 682 0 556 -78 622 -31 z '
    },
    Ŵ: {
      ha: 1253,
      x_min: 0,
      x_max: 0,
      o:
        'm 1200 972 l 1133 972 l 932 89 l 664 972 l 589 972 l 321 89 l 119 972 l 53 972 l 283 0 l 354 0 l 626 900 l 899 0 l 969 0 z m 658 1225 l 594 1225 l 436 1060 l 504 1060 l 626 1188 l 749 1060 l 817 1060 z '
    },
    ŵ: {
      ha: 1036,
      x_min: 0,
      x_max: 0,
      o:
        'm 983 706 l 921 706 l 753 79 l 553 706 l 483 706 l 283 79 l 115 706 l 53 706 l 249 0 l 315 0 l 518 633 l 721 0 l 788 0 z m 550 999 l 486 999 l 333 810 l 399 810 l 518 957 l 638 810 l 703 810 z '
    },
    Ŷ: {
      ha: 808,
      x_min: 0,
      x_max: 0,
      o:
        'm 438 376 l 786 972 l 715 972 l 404 439 l 93 972 l 22 972 l 371 376 l 371 0 l 438 0 z m 436 1225 l 372 1225 l 214 1060 l 282 1060 l 404 1188 l 526 1060 l 594 1060 z '
    },
    ŷ: {
      ha: 685,
      x_min: 0,
      x_max: 0,
      o:
        'm 228 -242 l 293 -242 l 381 3 l 638 706 l 569 706 l 344 81 l 115 706 l 47 706 l 311 0 z m 385 999 l 321 999 l 168 810 l 233 810 l 353 957 l 472 810 l 538 810 z '
    },
    Ÿ: {
      ha: 808,
      x_min: 0,
      x_max: 0,
      o:
        'm 438 376 l 786 972 l 715 972 l 404 439 l 93 972 l 22 972 l 371 376 l 371 0 l 438 0 z m 197 1135 b 249 1085 197 1110 217 1085 b 300 1135 281 1085 300 1110 b 249 1185 300 1161 281 1185 b 197 1135 217 1185 197 1161 z m 508 1135 b 560 1085 508 1110 528 1085 b 611 1135 592 1085 611 1110 b 560 1185 611 1161 592 1185 b 508 1135 528 1185 508 1161 z '
    },
    Ź: {
      ha: 856,
      x_min: 0,
      x_max: 0,
      o:
        'm 94 0 l 764 0 l 764 57 l 167 57 l 747 915 l 747 972 l 121 972 l 121 915 l 675 915 l 94 57 z m 392 1060 l 458 1060 l 575 1225 l 494 1225 z '
    },
    ź: {
      ha: 682,
      x_min: 0,
      x_max: 0,
      o:
        'm 83 0 l 606 0 l 606 56 l 157 56 l 600 653 l 600 706 l 101 706 l 101 650 l 526 650 l 83 53 z m 301 810 l 368 810 l 499 999 l 419 999 z '
    },
    Ż: {
      ha: 856,
      x_min: 0,
      x_max: 0,
      o:
        'm 94 0 l 764 0 l 764 57 l 167 57 l 747 915 l 747 972 l 121 972 l 121 915 l 675 915 l 94 57 z m 381 1136 b 433 1085 381 1111 400 1085 b 486 1136 467 1085 486 1111 b 433 1188 486 1164 467 1188 b 381 1136 400 1188 381 1164 z '
    },
    ż: {
      ha: 682,
      x_min: 0,
      x_max: 0,
      o:
        'm 83 0 l 606 0 l 606 56 l 157 56 l 600 653 l 600 706 l 101 706 l 101 650 l 526 650 l 83 53 z m 297 914 b 350 863 297 889 317 863 b 403 914 383 863 403 889 b 350 965 403 942 383 965 b 297 914 317 965 297 942 z '
    },
    Ž: {
      ha: 856,
      x_min: 0,
      x_max: 0,
      o:
        'm 94 0 l 764 0 l 764 57 l 167 57 l 747 915 l 747 972 l 121 972 l 121 915 l 675 915 l 94 57 z m 632 1225 l 564 1225 l 442 1097 l 319 1225 l 251 1225 l 410 1060 l 474 1060 z '
    },
    ž: {
      ha: 682,
      x_min: 0,
      x_max: 0,
      o:
        'm 83 0 l 606 0 l 606 56 l 157 56 l 600 653 l 600 706 l 101 706 l 101 650 l 526 650 l 83 53 z m 543 999 l 478 999 l 358 851 l 239 999 l 174 999 l 326 810 l 390 810 z '
    },
    ƒ: {
      ha: 701,
      x_min: 0,
      x_max: 0,
      o:
        'm 63 -242 l 144 -242 b 324 -65 261 -242 314 -174 l 374 504 l 554 504 l 554 558 l 378 558 l 399 793 b 522 918 407 888 446 918 l 604 918 l 604 972 l 510 972 b 332 796 404 972 343 917 l 311 558 l 161 558 l 161 504 l 307 504 l 257 -64 b 133 -187 250 -149 217 -187 l 63 -187 z '
    },
    Ǻ: {
      ha: 919,
      x_min: 0,
      x_max: 0,
      o:
        'm 579 1042 b 460 1149 579 1103 533 1149 b 340 1042 386 1149 340 1103 b 413 942 340 994 367 957 l 56 0 l 126 0 l 224 267 l 694 267 l 793 0 l 864 0 l 506 942 b 579 1042 551 957 579 994 z m 460 908 l 674 324 l 244 324 z m 460 972 b 383 1042 411 972 383 1000 b 460 1111 383 1083 411 1111 b 536 1042 508 1111 536 1083 b 460 972 536 1000 508 972 z m 442 1197 l 508 1197 l 604 1333 l 524 1333 z '
    },
    ǻ: {
      ha: 771,
      x_min: 0,
      x_max: 0,
      o:
        'm 386 1057 l 453 1057 l 547 1193 l 468 1193 z m 408 821 b 332 892 360 821 332 850 b 408 963 332 933 360 963 b 485 892 457 963 485 933 b 408 821 485 850 457 821 z m 408 783 b 528 892 482 783 528 831 b 408 1000 528 953 482 1000 b 289 892 335 1000 289 953 b 408 783 289 831 335 783 z m 344 -17 b 599 99 463 -17 561 39 l 599 0 l 663 0 l 663 465 b 394 722 663 611 554 722 b 125 538 263 722 158 654 l 188 538 b 394 668 221 618 290 668 b 596 463 519 668 596 579 l 596 322 b 356 428 557 374 465 428 b 72 210 190 428 72 347 b 344 -17 72 78 181 -17 z m 349 35 b 136 208 222 35 136 101 b 356 375 136 319 231 375 b 596 208 467 375 596 314 b 349 35 596 94 467 35 z '
    },
    Ǽ: {
      ha: 1426,
      x_min: 0,
      x_max: 0,
      o:
        'm 740 1060 l 807 1060 l 924 1225 l 843 1225 z m 721 0 l 1346 0 l 1346 57 l 789 57 l 789 464 l 1304 464 l 1304 522 l 789 522 l 789 915 l 1344 915 l 1344 972 l 690 972 l 24 0 l 97 0 l 285 276 l 721 276 z m 322 332 l 721 917 l 721 332 z '
    },
    ǽ: {
      ha: 1281,
      x_min: 0,
      x_max: 0,
      o:
        'm 603 810 l 669 810 l 800 999 l 721 999 z m 901 -17 b 1179 196 1044 -17 1151 71 l 1121 196 b 901 36 1092 101 1017 36 b 663 282 746 36 663 144 l 663 324 l 1189 324 l 1189 418 b 897 722 1189 583 1086 722 b 635 578 772 722 682 668 b 393 722 594 661 508 722 b 126 536 257 722 161 656 l 188 536 b 393 668 221 619 283 668 b 596 461 518 668 596 572 l 596 332 b 356 431 556 383 461 431 b 72 211 188 431 72 350 b 356 -17 72 86 174 -17 b 632 131 490 -17 596 51 b 901 -17 681 39 775 -17 z m 351 35 b 136 210 225 35 136 103 b 354 378 136 324 232 378 b 596 213 465 378 596 319 b 351 35 596 101 479 35 z m 663 411 b 897 669 663 565 739 669 b 1125 421 1049 669 1125 560 l 1125 378 l 663 378 z '
    },
    Ǿ: {
      ha: 1006,
      x_min: 0,
      x_max: 0,
      o:
        'm 464 1060 l 531 1060 l 647 1225 l 567 1225 z m 899 569 b 790 878 899 690 863 800 l 899 1042 l 840 1042 l 754 911 b 503 992 692 961 608 992 b 107 569 235 992 107 799 l 107 403 b 214 94 107 282 142 172 l 107 -69 l 165 -69 l 251 60 b 503 -19 314 10 397 -19 b 899 403 771 -19 899 174 z m 832 400 b 503 36 832 206 731 36 b 285 111 410 36 338 64 l 754 824 b 832 572 807 757 832 672 z m 174 400 l 174 572 b 503 936 174 767 275 936 b 721 861 596 936 668 907 l 250 149 b 174 400 197 215 174 300 z '
    },
    ǿ: {
      ha: 778,
      x_min: 0,
      x_max: 0,
      o:
        'm 349 810 l 415 810 l 546 999 l 467 999 z m 389 -17 b 693 290 581 -17 693 118 l 693 415 b 604 642 693 506 661 586 l 693 776 l 639 776 l 569 671 b 389 722 521 703 460 722 b 85 415 197 722 85 588 l 85 290 b 172 64 85 200 115 119 l 85 -69 l 139 -69 l 207 35 b 389 -17 256 1 317 -17 z m 629 413 l 629 293 b 389 38 629 147 543 38 b 239 83 328 38 278 54 l 571 590 b 629 413 608 544 629 482 z m 149 293 l 149 413 b 389 668 149 558 235 668 b 538 622 449 668 499 651 l 206 115 b 149 293 168 161 149 222 z '
    },
    Ș: {
      ha: 906,
      x_min: 0,
      x_max: 0,
      o:
        'm 458 -19 b 813 258 654 -19 813 82 b 614 489 813 379 735 457 l 324 565 b 186 736 231 590 186 642 b 443 936 186 861 286 936 b 711 717 607 936 711 846 l 711 696 l 774 696 l 774 718 b 443 992 774 879 638 992 b 121 732 250 992 121 893 b 304 508 121 615 188 539 l 592 433 b 747 254 693 407 747 344 b 458 36 747 115 625 36 b 169 268 289 36 169 126 l 169 289 l 104 289 l 104 267 b 458 -19 104 94 256 -19 z m 379 -347 l 435 -347 l 510 -115 l 438 -115 z '
    },
    ș: {
      ha: 729,
      x_min: 0,
      x_max: 0,
      o:
        'm 372 -17 b 653 189 524 -17 653 64 b 496 363 653 279 601 336 l 267 419 b 171 528 204 435 171 468 b 360 668 171 617 243 668 b 551 504 481 668 551 601 l 551 500 l 617 500 l 617 504 b 360 722 617 633 511 722 b 106 528 208 722 106 647 b 254 360 106 439 160 383 l 486 303 b 588 188 556 286 588 246 b 374 38 588 94 493 38 b 151 203 251 38 151 99 l 151 206 l 86 206 l 86 201 b 372 -17 86 68 210 -17 z m 297 -347 l 353 -347 l 428 -115 l 356 -115 z '
    },
    ˆ: { ha: 642, x_min: 0, x_max: 0, o: 'm 353 999 l 289 999 l 136 810 l 201 810 l 321 957 l 440 810 l 506 810 z ' },
    ˇ: { ha: 642, x_min: 0, x_max: 0, o: 'm 506 999 l 440 999 l 321 851 l 201 999 l 136 999 l 289 810 l 353 810 z ' },
    '˘': {
      ha: 683,
      x_min: 0,
      x_max: 0,
      o:
        'm 342 810 b 547 999 476 810 547 893 l 494 999 b 342 854 494 914 444 854 b 189 999 239 854 189 914 l 136 999 b 342 810 136 893 207 810 z '
    },
    '˙': {
      ha: 378,
      x_min: 0,
      x_max: 0,
      o: 'm 136 914 b 189 863 136 889 156 863 b 242 914 222 863 242 889 b 189 965 242 942 222 965 b 136 914 156 965 136 942 z '
    },
    '˚': {
      ha: 511,
      x_min: 0,
      x_max: 0,
      o:
        'm 256 847 b 179 921 207 847 179 879 b 256 994 179 963 207 994 b 332 921 304 994 332 963 b 256 847 332 879 304 847 z m 256 810 b 375 921 329 810 375 860 b 256 1032 375 982 329 1032 b 136 921 182 1032 136 982 b 256 810 136 860 182 810 z '
    },
    '˛': {
      ha: 457,
      x_min: 0,
      x_max: 0,
      o:
        'm 254 -258 b 321 -250 278 -258 306 -254 l 321 -206 b 274 -210 307 -208 290 -210 b 194 -149 222 -210 194 -190 b 321 0 194 -78 256 -40 l 257 0 b 136 -153 204 -21 136 -75 b 254 -258 136 -217 179 -258 z '
    },
    '˜': {
      ha: 735,
      x_min: 0,
      x_max: 0,
      o:
        'm 183 821 b 263 925 197 878 210 925 b 482 826 331 925 414 826 b 599 967 558 826 583 900 l 551 976 b 482 874 540 928 531 874 b 261 972 428 874 346 972 b 136 831 182 972 149 910 z '
    },
    '˝': { ha: 693, x_min: 0, x_max: 0, o: 'm 136 810 l 196 810 l 301 999 l 231 999 z m 392 810 l 451 810 l 557 999 l 486 999 z ' },
    '̒': { ha: 394, x_min: 0, x_max: 0, o: 'm 135 810 l 214 810 l 260 999 l 196 999 z ' },
    '̕': { ha: 399, x_min: 0, x_max: 0, o: 'm 135 760 l 190 760 l 263 1014 l 190 1014 z ' },
    '̦': { ha: 401, x_min: 0, x_max: 0, o: 'm 135 -347 l 190 -347 l 265 -115 l 193 -115 z ' },
    Ω: {
      ha: 997,
      x_min: 0,
      x_max: 0,
      o:
        'm 872 54 l 711 54 b 883 479 801 154 883 311 l 883 557 b 499 992 883 813 757 992 b 114 557 240 992 114 813 l 114 479 b 286 54 114 311 196 154 l 125 54 l 125 0 l 357 0 l 357 54 b 181 476 250 174 181 324 l 181 556 b 499 938 181 782 286 938 b 817 556 711 938 817 782 l 817 476 b 640 54 817 324 747 174 l 640 0 l 872 0 z '
    },
    π: {
      ha: 1010,
      x_min: 0,
      x_max: 0,
      o:
        'm 251 0 l 318 0 l 318 651 l 658 651 l 658 183 b 829 0 658 69 710 0 l 914 0 l 914 54 l 842 54 b 725 185 756 54 725 97 l 725 651 l 917 651 l 917 706 l 93 706 l 93 651 l 251 651 z '
    },
    Ẁ: {
      ha: 1253,
      x_min: 0,
      x_max: 0,
      o:
        'm 1200 972 l 1133 972 l 932 89 l 664 972 l 589 972 l 321 89 l 119 972 l 53 972 l 283 0 l 354 0 l 626 900 l 899 0 l 969 0 z m 581 1060 l 647 1060 l 544 1225 l 464 1225 z '
    },
    ẁ: {
      ha: 1036,
      x_min: 0,
      x_max: 0,
      o:
        'm 983 706 l 921 706 l 753 79 l 553 706 l 483 706 l 283 79 l 115 706 l 53 706 l 249 0 l 315 0 l 518 633 l 721 0 l 788 0 z m 415 999 l 336 999 l 467 810 l 533 810 z '
    },
    Ẃ: {
      ha: 1253,
      x_min: 0,
      x_max: 0,
      o:
        'm 1200 972 l 1133 972 l 932 89 l 664 972 l 589 972 l 321 89 l 119 972 l 53 972 l 283 0 l 354 0 l 626 900 l 899 0 l 969 0 z m 607 1060 l 674 1060 l 790 1225 l 710 1225 z '
    },
    ẃ: {
      ha: 1036,
      x_min: 0,
      x_max: 0,
      o:
        'm 983 706 l 921 706 l 753 79 l 553 706 l 483 706 l 283 79 l 115 706 l 53 706 l 249 0 l 315 0 l 518 633 l 721 0 l 788 0 z m 500 810 l 567 810 l 697 999 l 618 999 z '
    },
    Ẅ: {
      ha: 1253,
      x_min: 0,
      x_max: 0,
      o:
        'm 1200 972 l 1133 972 l 932 89 l 664 972 l 589 972 l 321 89 l 119 972 l 53 972 l 283 0 l 354 0 l 626 900 l 899 0 l 969 0 z m 419 1135 b 471 1085 419 1110 439 1085 b 522 1135 503 1085 522 1110 b 471 1185 522 1161 503 1185 b 419 1135 439 1185 419 1161 z m 731 1135 b 782 1085 731 1110 750 1085 b 833 1135 814 1085 833 1110 b 782 1185 833 1161 814 1185 b 731 1135 750 1185 731 1161 z '
    },
    ẅ: {
      ha: 1036,
      x_min: 0,
      x_max: 0,
      o:
        'm 983 706 l 921 706 l 753 79 l 553 706 l 483 706 l 283 79 l 115 706 l 53 706 l 249 0 l 315 0 l 518 633 l 721 0 l 788 0 z m 326 897 b 378 847 326 872 346 847 b 429 897 410 847 429 872 b 378 947 429 924 410 947 b 326 897 346 947 326 924 z m 607 897 b 658 847 607 872 626 847 b 710 897 690 847 710 872 b 658 947 710 924 690 947 b 607 897 626 947 607 924 z '
    },
    Ỳ: {
      ha: 808,
      x_min: 0,
      x_max: 0,
      o:
        'm 438 376 l 786 972 l 715 972 l 404 439 l 93 972 l 22 972 l 371 376 l 371 0 l 438 0 z m 375 1060 l 442 1060 l 339 1225 l 258 1225 z '
    },
    ỳ: {
      ha: 685,
      x_min: 0,
      x_max: 0,
      o:
        'm 228 -242 l 293 -242 l 381 3 l 638 706 l 569 706 l 344 81 l 115 706 l 47 706 l 311 0 z m 267 999 l 188 999 l 318 810 l 385 810 z '
    },
    '–': { ha: 850, x_min: 0, x_max: 0, o: 'm 101 403 l 749 403 l 749 457 l 101 457 z ' },
    '—': { ha: 1265, x_min: 0, x_max: 0, o: 'm 101 403 l 1164 403 l 1164 457 l 101 457 z ' },
    '‘': { ha: 289, x_min: 0, x_max: 0, o: 'm 210 972 l 154 972 l 71 688 l 146 688 z ' },
    '’': { ha: 289, x_min: 0, x_max: 0, o: 'm 79 688 l 135 688 l 218 972 l 143 972 z ' },
    '‚': { ha: 308, x_min: 0, x_max: 0, o: 'm 56 -149 l 111 -149 l 194 136 l 119 136 z ' },
    '“': { ha: 550, x_min: 0, x_max: 0, o: 'm 471 972 l 415 972 l 332 688 l 407 688 z m 210 972 l 154 972 l 71 688 l 146 688 z ' },
    '”': { ha: 550, x_min: 0, x_max: 0, o: 'm 79 688 l 135 688 l 218 972 l 143 972 z m 340 688 l 396 688 l 479 972 l 404 972 z ' },
    '„': { ha: 569, x_min: 0, x_max: 0, o: 'm 56 -149 l 111 -149 l 194 136 l 119 136 z m 317 -149 l 372 -149 l 456 136 l 381 136 z ' },
    '†': {
      ha: 689,
      x_min: 0,
      x_max: 0,
      o: 'm 317 -139 l 372 -139 l 372 665 l 581 665 l 581 713 l 372 713 l 372 972 l 317 972 l 317 713 l 108 713 l 108 665 l 317 665 z '
    },
    '‡': {
      ha: 703,
      x_min: 0,
      x_max: 0,
      o:
        'm 324 168 l 115 168 l 115 121 l 324 121 l 324 -139 l 379 -139 l 379 121 l 588 121 l 588 168 l 379 168 l 379 665 l 588 665 l 588 713 l 379 713 l 379 972 l 324 972 l 324 713 l 115 713 l 115 665 l 324 665 z '
    },
    '•': {
      ha: 575,
      x_min: 0,
      x_max: 0,
      o: 'm 288 346 b 440 494 381 346 440 408 b 288 643 440 581 381 643 b 135 494 194 643 135 581 b 288 346 135 408 194 346 z '
    },
    '…': {
      ha: 925,
      x_min: 0,
      x_max: 0,
      o:
        'm 100 46 b 154 -8 100 14 124 -8 b 208 46 185 -8 208 14 b 154 100 208 78 185 100 b 100 46 124 100 100 78 z m 408 46 b 463 -8 408 14 432 -8 b 517 46 493 -8 517 14 b 463 100 517 78 493 100 b 408 46 432 100 408 78 z m 717 46 b 771 -8 717 14 740 -8 b 825 46 801 -8 825 14 b 771 100 825 78 801 100 b 717 46 740 100 717 78 z '
    },
    '‰': {
      ha: 1678,
      x_min: 0,
      x_max: 0,
      o:
        'm 306 0 l 360 0 l 867 972 l 813 972 z m 500 779 b 299 983 500 899 425 983 b 97 779 172 983 97 899 l 97 651 b 299 447 97 532 172 447 b 500 651 425 447 500 532 z m 299 490 b 149 649 204 490 149 554 l 149 782 b 299 940 149 876 204 940 b 449 782 394 940 449 878 l 449 649 b 299 490 449 553 394 490 z m 1074 321 b 872 525 1074 440 999 525 b 671 321 746 525 671 440 l 671 193 b 872 -11 671 74 746 -11 b 1074 193 999 -11 1074 74 z m 872 32 b 722 190 778 32 722 96 l 722 324 b 872 482 722 418 778 482 b 1022 324 968 482 1022 419 l 1022 190 b 872 32 1022 94 968 32 z m 1588 321 b 1386 525 1588 440 1513 525 b 1185 321 1260 525 1185 440 l 1185 193 b 1386 -11 1185 74 1260 -11 b 1588 193 1513 -11 1588 74 z m 1386 32 b 1236 190 1292 32 1236 96 l 1236 324 b 1386 482 1236 418 1292 482 b 1536 324 1482 482 1536 419 l 1536 190 b 1386 32 1536 94 1482 32 z '
    },
    '‹': { ha: 465, x_min: 0, x_max: 0, o: 'm 304 83 l 379 83 l 135 375 l 379 667 l 304 667 l 58 375 z ' },
    '›': { ha: 465, x_min: 0, x_max: 0, o: 'm 407 375 l 161 667 l 86 667 l 331 375 l 86 83 l 161 83 z ' },
    '⁄': { ha: 506, x_min: 0, x_max: 0, o: 'm -28 0 l 26 0 l 533 972 l 479 972 z ' },
    '€': {
      ha: 914,
      x_min: 0,
      x_max: 0,
      o:
        'm 69 583 l 185 583 l 185 389 l 69 389 l 69 335 l 185 335 l 185 297 b 504 -19 185 119 296 -19 b 817 268 690 -19 801 119 l 754 268 b 504 35 738 143 654 35 b 251 296 338 35 251 139 l 251 335 l 578 335 l 578 389 l 251 389 l 251 583 l 578 583 l 578 638 l 251 638 l 251 676 b 504 938 251 833 338 938 b 754 704 654 938 738 829 l 817 704 b 504 992 801 853 690 992 b 185 675 296 992 185 853 l 185 638 l 69 638 z '
    },
    '℗': {
      ha: 1211,
      x_min: 0,
      x_max: 0,
      o:
        'm 464 239 l 506 239 l 506 421 l 649 421 b 811 575 747 421 811 489 b 649 731 811 663 749 731 l 464 731 z m 506 456 l 506 696 l 642 696 b 769 575 728 696 769 639 b 642 456 769 510 728 456 z m 606 989 b 107 486 301 989 107 757 b 606 -17 107 215 301 -17 b 1104 486 910 -17 1104 215 b 606 989 1104 757 910 989 z m 606 11 b 138 486 314 11 138 231 b 606 961 138 742 314 961 b 1074 486 897 961 1074 742 b 606 11 1074 231 897 11 z '
    },
    '™': {
      ha: 899,
      x_min: 0,
      x_max: 0,
      o:
        'm 208 578 l 246 578 l 246 942 l 372 942 l 372 972 l 81 972 l 81 942 l 208 942 z m 792 972 l 754 972 l 622 714 l 490 972 l 453 972 l 453 578 l 488 578 l 488 907 l 603 682 l 642 682 l 757 907 l 757 578 l 792 578 z '
    },
    '∂': {
      ha: 811,
      x_min: 0,
      x_max: 0,
      o:
        'm 400 -19 b 721 307 594 -19 721 124 l 721 382 b 201 972 721 704 592 972 l 178 972 l 178 918 l 197 918 b 657 492 518 918 628 733 b 393 640 624 564 532 640 b 90 331 210 640 90 518 l 90 289 b 400 -19 90 119 215 -19 z m 401 33 b 156 288 260 33 156 135 l 156 332 b 406 588 156 492 247 588 b 656 338 540 588 656 474 l 656 293 b 401 33 656 144 553 33 z '
    },
    '∆': { ha: 922, x_min: 0, x_max: 0, o: 'm 832 50 l 493 972 l 429 972 l 90 50 l 90 0 l 832 0 z m 767 54 l 156 54 l 461 908 z ' },
    '∏': {
      ha: 1094,
      x_min: 0,
      x_max: 0,
      o: 'm 279 -242 l 346 -242 l 346 918 l 749 918 l 749 -242 l 815 -242 l 815 918 l 1008 918 l 1008 972 l 86 972 l 86 918 l 279 918 z '
    },
    '∑': {
      ha: 850,
      x_min: 0,
      x_max: 0,
      o: 'm 114 918 l 461 365 l 114 -187 l 114 -242 l 750 -242 l 750 -187 l 186 -187 l 531 365 l 186 918 l 750 918 l 750 972 l 114 972 z '
    },
    '−': { ha: 831, x_min: 0, x_max: 0, o: 'm 118 474 l 713 474 l 713 526 l 118 526 z ' },
    '√': {
      ha: 954,
      x_min: 0,
      x_max: 0,
      o: 'm 471 -139 l 550 -139 l 850 1042 l 792 1042 l 507 -82 l 324 444 l 97 444 l 97 389 l 281 389 z '
    },
    '∞': {
      ha: 1214,
      x_min: 0,
      x_max: 0,
      o:
        'm 879 274 b 1106 500 1010 274 1106 364 b 879 726 1106 636 1010 726 b 607 550 746 726 649 631 b 335 726 565 631 468 726 b 108 500 204 726 108 636 b 335 274 108 364 204 274 b 607 450 468 274 565 369 b 879 274 649 369 746 274 z m 872 325 b 636 500 747 325 671 425 b 872 675 671 575 747 675 b 1049 500 972 675 1049 607 b 872 325 1049 393 972 325 z m 342 325 b 165 500 242 325 165 393 b 342 675 165 607 242 675 b 578 500 467 675 543 575 b 342 325 543 425 467 325 z '
    },
    '∫': {
      ha: 613,
      x_min: 0,
      x_max: 0,
      o:
        'm 86 -242 l 142 -242 b 333 -49 271 -242 333 -178 l 333 781 b 464 918 333 879 364 918 l 513 918 l 513 972 l 456 972 b 267 781 318 972 267 906 l 267 -51 b 131 -187 267 -149 226 -187 l 86 -187 z '
    },
    '≈': {
      ha: 825,
      x_min: 0,
      x_max: 0,
      o:
        'm 571 293 b 721 365 639 293 690 328 l 690 399 b 571 344 658 364 625 344 b 433 390 518 344 482 364 b 278 440 382 417 336 440 b 111 351 201 440 154 400 l 146 318 b 275 389 183 357 217 389 b 415 343 325 389 364 369 b 571 293 465 318 513 293 z m 571 561 b 721 633 639 561 690 596 l 690 667 b 571 613 658 632 625 613 b 433 658 518 613 482 632 b 278 708 382 685 336 708 b 111 619 201 708 154 668 l 146 586 b 275 657 183 625 217 657 b 415 611 325 657 364 638 b 571 561 465 586 513 561 z '
    },
    '≠': {
      ha: 865,
      x_min: 0,
      x_max: 0,
      o:
        'm 139 639 l 474 639 l 332 361 l 139 361 l 139 310 l 306 310 l 215 132 l 272 132 l 363 310 l 726 310 l 726 361 l 389 361 l 532 639 l 726 639 l 726 690 l 558 690 l 650 868 l 592 868 l 500 690 l 139 690 z '
    },
    '≤': {
      ha: 858,
      x_min: 0,
      x_max: 0,
      o: 'm 118 0 l 726 0 l 726 54 l 118 54 z m 118 546 l 118 496 l 726 222 l 726 282 l 196 521 l 726 760 l 726 819 z '
    },
    '≥': {
      ha: 858,
      x_min: 0,
      x_max: 0,
      o: 'm 740 54 l 132 54 l 132 0 l 740 0 z m 132 819 l 132 760 l 663 521 l 132 282 l 132 222 l 740 496 l 740 546 z '
    },
    '◊': {
      ha: 900,
      x_min: 0,
      x_max: 0,
      o: 'm 800 486 l 479 972 l 421 972 l 100 486 l 421 0 l 479 0 z m 450 54 l 167 486 l 450 918 l 733 486 z '
    },
    '': {
      ha: 1204,
      x_min: 0,
      x_max: 0,
      o:
        'm 163 226 b 406 -17 163 89 268 -17 b 649 226 543 -17 649 89 l 649 489 l 892 489 b 1135 731 1029 489 1135 593 b 892 972 1135 868 1029 972 l 406 972 b 163 729 268 972 163 867 z '
    },
    ﬁ: {
      ha: 800,
      x_min: 0,
      x_max: 0,
      o:
        'm 172 0 l 239 0 l 239 651 l 432 651 l 432 706 l 239 706 l 239 814 b 376 960 239 913 275 960 l 457 960 l 457 1014 l 372 1014 b 172 808 238 1014 172 950 l 172 706 l 63 706 l 63 651 l 172 651 z m 606 0 l 672 0 l 672 706 l 606 706 z m 586 914 b 639 863 586 889 606 863 b 692 914 672 863 692 889 b 639 965 692 942 672 965 b 586 914 606 965 586 942 z '
    },
    ﬂ: {
      ha: 800,
      x_min: 0,
      x_max: 0,
      o:
        'm 172 0 l 239 0 l 239 651 l 432 651 l 432 706 l 239 706 l 239 814 b 376 960 239 913 275 960 l 457 960 l 457 1014 l 372 1014 b 172 808 238 1014 172 950 l 172 706 l 63 706 l 63 651 l 172 651 z m 606 0 l 672 0 l 672 1014 l 606 1014 z '
    }
  },
  familyName: 'Colfax',
  ascender: 1042,
  descender: -347,
  underlinePosition: -124,
  underlineThickness: 32,
  boundingBox: { yMin: -347, xMin: -69, yMax: 1333, xMax: 1588 },
  resolution: 1000,
  original_font_information: {
    format: 0,
    copyright: 'Copyright (c) 2012 by Process Type Foundry, LLC. All rights reserved.',
    fontFamily: 'Colfax',
    fontSubfamily: 'Light',
    uniqueID: 'ProcessTypeFoundry: Chrono Light: 2012',
    fullName: 'Colfax-Light',
    version: 'Version 1.000',
    postScriptName: 'Colfax-Light',
    trademark: 'Chrono is a trademark of Process Type Foundry, LLC.',
    manufacturer: 'Process Type Foundry',
    designer: 'Eric Olson',
    description: 'Copyright (c) 2012 by Process Type Foundry, LLC. All rights reserved.',
    manufacturerURL: 'http://www.processtypefoundry.com',
    designerURL: 'http://www.processtypefoundry.com',
    licenceURL: 'http://processtypefoundry.com/licensing/our-license-agreement'
  },
  cssFontWeight: 'normal',
  cssFontStyle: 'normal'
}
